<template>
    <div class="profile">
        <div class="tabs-content">
            <div class="container">
                <h2>your profile</h2>
                <div class="tabs">
<!--                    <ul>-->
<!--                        <li v-bind:style="[tabs.playlist ? {'borderBottom': '3px solid ' + getCorpHeaderColor + ' !important'} : {'borderBottom': '0px solid #333 !important'}]"  @click="$router.push('/profile/playlist')" :class="{ current: tabs.playlist }" class="playlist"><a href="javascript:" v-bind:style="[tabs.playlist ? {'color': getCorpHeadingColor} : {'color': '#333'}]">playlists</a></li>-->
<!--                        <li  @click="$router.push('/profile/myprogress')" :class="{ current: tabs.coolFeatures }" class="videoList"><a href="javascript:" v-bind:style="[tabs.coolFeatures ? {'color': getCorpHeadingColor} : {'color': '#333'}]">your Progress</a></li>-->
<!--                        <li  @click="$router.push('/profile/personalize')" :class="{ current: tabs.chat }" class="videoList"><a href="javascript:" v-bind:style="[tabs.chat ? {'color': getCorpHeadingColor} : {'color': '#333'}]">personalize</a></li>-->
<!--                        <li  @click="$router.push('/profile/myfav')" :class="{ current: tabs.videos }" class="videoList"><a href="javascript:" v-bind:style="[tabs.videos ? {'color': getCorpHeadingColor} : {'color': '#333'}]">your faves</a></li>-->
<!--                        <li  @click="switchTab('discussion')" :class="{ current: tabs.discussion }" class="videoList"><a href="javascript:" v-bind:style="[tabs.discussion ? {'color': getCorpHeadingColor} : {'color': '#333'}]">account</a></li>-->
<!--                    </ul>-->
                    <ul>
                        <li v-bind:style="[tabs.playlist ? {'borderBottom': '3px solid ' + getCorpHeaderColor + ' !important'} : {'borderBottom': '0px solid #333 !important'}]" @click="$router.push('/profile/playlist')" :class="{ current: tabs.playlist }" class="playlist"><a href="javascript:" v-bind:style="[tabs.playlist ? {'color': getCorpHeadingColor} : {'color': '#333'}]">playlists</a></li>
                        <li v-bind:style="[tabs.coolFeatures ? {'borderBottom': '3px solid ' + getCorpHeaderColor + ' !important'} : {'borderBottom': '0px solid #333 !important'}]" @click="$router.push('/profile/myprogress')" :class="{ current: tabs.coolFeatures }" class="videoList"><a href="javascript:" v-bind:style="[tabs.coolFeatures ? {'color': getCorpHeadingColor} : {'color': '#333'}]">your Progress</a></li>
                        <li v-bind:style="[tabs.chat ? {'borderBottom': '3px solid ' + getCorpHeaderColor + ' !important'} : {'borderBottom': '0px solid #333 !important'}]" @click="$router.push('/profile/personalize')" :class="{ current: tabs.chat }" class="videoList"><a href="javascript:" v-bind:style="[tabs.chat ? {'color': getCorpHeadingColor} : {'color': '#333'}]">personalize</a></li>
                        <li v-bind:style="[tabs.videos ? {'borderBottom': '3px solid ' + getCorpHeaderColor + ' !important'} : {'borderBottom': '0px solid #333 !important'}]" @click="$router.push('/profile/myfav')" :class="{ current: tabs.videos }" class="videoList"><a href="javascript:" v-bind:style="[tabs.videos ? {'color': getCorpHeadingColor} : {'color': '#333'}]">your faves</a></li>
                        <li v-bind:style="[tabs.discussion ? {'borderBottom': '3px solid ' + getCorpHeaderColor + ' !important'} : {'borderBottom': '0px solid #333 !important'}]" @click="switchTab('discussion')" :class="{ current: tabs.discussion }" class="videoList"><a href="javascript:" v-bind:style="[tabs.discussion ? {'color': getCorpHeadingColor} : {'color': '#333'}]">account</a></li>
                    </ul>
                </div>
            </div>
            <div class="container-fluid">
                <div class="row">
                    <!--////////////////////// first box start here ////////////////////////-->
                    <!--                            <h2 class="heading"><strong>{{progressHeading1}}</strong></h2>-->
                    <!--                            <h3 class="heading">{{progressHeading2}}</h3>-->
                    <!--                            <h3 class="heading">{{progressHeading3}}</h3>-->
                    <div class="tabContent" id="tabs-5" :class="{ current: tabs.coolFeatures }">
                        <div class="container">
                            <h2 class="heading" v-bind:style="{ color: getCorpHeadingColor}" v-if="!userProgressTakeaways"><strong  v-bind:style="{ color: getCorpHeadingColor}">Look what You’ve Accomplished!</strong></h2><h2 class="heading" v-else><strong  v-bind:style="{ color: getCorpHeadingColor}">{{progressHeading1}}</strong></h2>
                            <h3 class="heading"  v-bind:style="{ color: getCorpHeadingColor}" v-if="!userProgressTakeaways">Now is the BEST time to invest in YOU.</h3><h3 class="heading"  v-bind:style="{ color: getCorpHeadingColor}" v-else>{{progressHeading2}}</h3>
                            <h3 class="heading" v-bind:style="{ color: getCorpHeadingColor}" v-if="userProgressTakeaways">{{progressHeading3}}</h3>
                            <div class="row">
                                <div class="col-md-3 bottom-margin">
                                    <div class="progressbarsholder"  v-bind:style="{ backgroundColor: getCorpHeaderColor +' !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}" :class="{'expand': expandPlaylistPanel}">
                                        <h3 v-if="isPlaylistWatched">Playlists in Progress</h3><h3 v-else>Playlists for You</h3>
                                        <div v-for="playlist in userProgressPlaylists">
                                         <h4 style="cursor: pointer" @click="playProgressPlaylist(playlist.playlistId, playlist.playlistTypeDesc, playlist.title, playlist.lastSeenVideoCode, playlist.lastSeenVideoTitle)">{{playlist.title}}</h4>
                                        <div class="progessandstar">
                                            <div class="progress  mb-3">
                                                <div d role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" class="progress-bar" :style="returnProgressStyle(Math.round(playlist.percentWatched))">
                                                </div>
                                            </div>
                                            <i v-if="Math.round(playlist.percentWatched) === 100" class="fa fa-star"></i>
                                        </div>
                                        </div>
<!--                                        <h4>progress bar heading</h4>-->
<!--                                        <div class="progessandstar"><div class="progress  mb-3"><div d role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" class="progress-bar" style="width: 25%;"></div></div><i class="fa fa-star"></i></div>-->
<!--                                        <h4>progsress bar heading</h4>-->
<!--                                        <div class="progessandstar"><div class="progress  mb-3"><div d role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" class="progress-bar" style="width: 25%;"></div></div><i class="fa fa-star"></i></div>-->
<!--                                        <h4>progress bar heading</h4>-->
<!--                                        <div class="progessandstar"><div class="progress  mb-3"><div d role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" class="progress-bar" style="width: 25%;"></div></div><i class="fa fa-star"></i></div>-->
<!--                                        <h4>progress bar heading</h4>-->
<!--                                        <div class="progessandstar"><div class="progress  mb-3"><div d role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" class="progress-bar" style="width: 25%;"></div></div><i class="fa fa-star"></i></div>-->
                                        <button class="downbutton"  @click="expandPlaylistPanel = !expandPlaylistPanel" v-bind:style="{ backgroundColor: getCorpHeaderColor +' !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}"><i class="fa fa-chevron-down"></i></button>
                                    </div>
                                </div>
                                <div class="col-md-6 bottom-margin">
                                    <div class="pinkputlinepannel"  v-bind:style="{  borderWidth: '5px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}" :class="{'expand': expandEventsAttendedPanel}">
                                        <div v-if="userProgressEventsAttended && userProgressEventsAttended.length > 0">
                                            <h3 :style="{color: getCorpHeadingColor}">Events Attended</h3>
                                            <ul>
<!--                                                <li v-for="event in userProgressEventsAttended">{{event.event_title}}<strong>&nbsp;&#45;&#45;&nbsp;&nbsp;{{event.expert_name}}&nbsp;</strong> </li>-->
                                                <li class="mobile-event-star" v-for="event in userProgressEventsAttended"><i class="fa fa-star showmobile"></i>{{event.event_title}}<strong>&nbsp;--&nbsp;&nbsp;{{event.expert_name}}&nbsp;</strong> </li>
                                            </ul>
                                        </div>
                                        <div v-else>
                                                <h3 v-if="upcomingProfileEvent && upcomingProfileEvent.start_date !== null" v-bind:style="{ color: getCorpHeadingColor}">Upcoming Event</h3>
                                            <h4 v-if="upcomingProfileEvent && upcomingProfileEvent.start_date !== null && getExpert" style="cursor: pointer;" @click="$router.push('/event')"><strong>{{upcomingProfileEvent.title}} with {{getExpert[0].name}} on {{getDateReference(upcomingProfileEvent.start_date, 'str')}}</strong></h4>
                                            <div class="clearfix"></div>
<!--                                            <div title="Add to Calendar" class="addeventatc pinkoutlinebtn">-->
<!--                                                Add to Calendar-->
<!--                                                <span class="start">{{upcomingProfileEvent.start_date}}</span>-->
<!--                                                <span class="end">{{upcomingProfileEvent.end_date}}</span>-->
<!--                                                <span class="timezone">America/New_York</span>-->
<!--                                                <span class="title">{{upcomingProfileEvent.title}}</span>-->
<!--                                                <span class="description">{{upcomingProfileEvent.longDescription}}</span>-->
<!--                                                <span class="location"><span v-if="upcomingProfileEvent.type === '1'">{{eventURL}}/event/{{upcomingProfileEvent.eventId}}</span><span v-else>{{eventURL}}/event/{{upcomingProfileEvent.eventId}}</span></span>-->
<!--                                            </div>-->
<!--                                            <br />-->
                                                <h4 style="text-align: justify;  text-justify: inter-word;" v-if="upcomingProfileEvent">{{upcomingProfileEvent.longDescription}}</h4>
                                            <h5 v-if="upcomingProfileEvent && upcomingProfileEvent.start_date !== null">{{getDateReference(upcomingProfileEvent.start_date, 'str')}}</h5>
                                                <div class="clearfix">
                                            </div>
                                        </div>
                                        <button class="downbutton"  @click="expandEventsAttendedPanel = !expandEventsAttendedPanel"><i  class="fa fa-chevron-down" v-bind:style="{ color: getCorpHeaderColor +' !important'}"></i></button>
                                    </div>
                                    <div class="pinkputlinepannel" v-bind:style="{ borderWidth: '5px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}" :class="{'expand': expandVideosWatchedPanel}">
                                        <h3 v-if="isSectionWatched" v-bind:style="{ color: getCorpHeadingColor}">Videos Watched</h3><h3 v-else v-bind:style="{ color: getCorpHeadingColor}">Here are some videos to get your started</h3>
                                        <div class="row">
                                        <div class="col-md-8">
                                            <ul>
                                                <li style="cursor: pointer;" v-for="video in userProgressVideosWatched" @click="playWatchedVideo(video.video_code, video.video_title)"><strong>{{video.video_title}}</strong></li>
                                            </ul>
                                        </div>
                                        <div class="col-md-4 watcedvideotitle" v-if="isSectionWatched" v-bind:style="{ color: getCorpHeadingColor}">
                                            TOTAL WATCHED <br />
                                            <span class="totalwatched"  v-if="userProgressVideosWatched">
                                               {{userProgressVideosWatched.length}}
                                            </span>
                                        </div>
                                        </div>
                                        <button class="downbutton" v-bind:style="{ color: getCorpHeaderColor}" @click="expandVideosWatchedPanel = !expandVideosWatchedPanel"><i class="fa fa-chevron-down"></i></button>
                                    </div>
                                </div>
                                <div class="col-md-3 bottom-margin">
                                    <div class="takeawaysholder" :class="{'expand': expandTakeawayPanel}">
                                        <h3>TONE TAKEAWAYS</h3>
                                        <div v-if="userProgressTakeaways && userProgressTakeaways.length > 0" v-for="takeaways in userProgressTakeaways">
                                            <h4><strong>{{takeaways.video_title}}</strong></h4>
                                        <ul>
                                            <li v-for="tk in takeaways.tone_takeaways"><strong>{{tk}}</strong></li>
                                        </ul>
                                            <div class="clearfix"></div>
                                        </div>
                                        <div v-if="!userProgressTakeaways">
                                            <h4><strong>make it easy!</strong></h4>
                                            <ul>
                                                <li>{{progressEmptyTakeawayHdng1}}</li>
                                                <li>{{progressEmptyTakeawayHdng2}}</li>
                                                <li>{{progressEmptyTakeawayHdng3}}</li>
                                                <li>{{progressEmptyTakeawayHdng4}}</li>
                                            </ul>
                                        </div>
                                        <button v-if="userProgressTakeaways && userProgressTakeaways.length > 0" class="downbutton"  v-bind:style="{ backgroundColor: getCorpHeaderColor}" @click="expandTakeawayPanel = !expandTakeawayPanel"><span v-if="expandTakeawayPanel"></span><span v-else >{{userProgressTakeaways ? 'MORE TAKEAWAYS' : ''}}</span><i class="fa fa-chevron-down"></i></button>
                                    </div>
                                </div>
                            </div>
                            <!----></div>
                    </div>
                    <div class="tabContent" id="tabs-1" :class="{ current: tabs.videos }">
                        <div class="container">
                            <div class="row yourFaves" v-if="getAuthUserFavVideos">
                                <!--<div class="col-md-12">-->
                                    <!--<div class="mostRecent">-->
                                        <!--<button type="button">-->
                                            <!--most recent-->
                                            <!--<i class="fa fa-angle-down" aria-hidden="true"></i>-->
                                        <!--</button>-->
                                        <!--<span>Sort by</span>-->
                                    <!--</div>-->
                                <!--</div>-->
                                <div class="col-xs-12 col-sm-6 col-md-4 bottom-margin" :class="{'innerimggray': getTrialDays < 0}" v-for = "video in getAuthUserFavVideos">
                                    <a :href="'/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" class="nounderline">
                                    <img class="jw-img" :src="video.image"  :alt="video.title" :title="video.title" />
                                    <p class="text-wrap-title cursor" >
                                        <i class="fa fa-play-circle-o"></i>
                                        {{video.title}}
                                    </p>
                                    </a>
                                    <div class="btn-group plusicon">
                                        <button :id="video.mediaid" type="button" @click="showPlaylistMenu(video.mediaid)" class="dropdown-toggle ellipsis pull-right">
<!--                                            <img src="../assets/playlist-icon.png" class="menuiconbutton" alt="PLAYLIST" title="Playlist"/>-->
                                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                 width="37px" height="24px" viewBox="0 0 37 24" enable-background="new 0 0 37 24" xml:space="preserve">
<rect y="0.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                <rect y="8.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                <rect y="17.2" :fill="getCorpHeaderColor" width="18.2" height="3"/>
                                                <rect x="23" y="15.2" :fill="getCorpHeaderColor" width="14" height="4"/>
                                                <rect x="27.958" y="10.242" :fill="getCorpHeaderColor" width="4" height="13.917"/>
</svg>
                                        </button>
                                        <ul class="hide">
                                            <li  v-if="getUserPlaylists">
                                                <label>
                                                    <b> Add to ...</b>
                                                </label>
                                            </li>
                                            <li role="separator" class="divider"  v-if="getUserPlaylists"></li>
                                            <li  v-if="getUserPlaylists" v-for="playlist in getUserPlaylists">
                                                <label class="notificationwithcheckboxes">
                                                    <input type="checkbox" :checked="verifyVideoExists(playlist, video)" @click="setPlaylistVideoStatus(video, playlist, verifyVideoExists(playlist, video)) "/> {{playlist.title}}
                                                    <transition name="fade">
                                                        <!--<h6 v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</h6>-->
                                                        <span class="added" v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</span>
                                                    </transition>
                                                    <transition name="fade">
                                                        <span class="removed" v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoRemoved">Removed</span>
                                                    </transition>
                                                </label>
                                            </li>
                                            <!--<li>-->
                                                <!--<label>-->
                                                    <!--<input type="checkbox" /> Second option-->
                                                <!--</label>-->
                                            <!--</li>-->
                                            <!--<li>-->
                                                <!--<label>-->
                                                    <!--<input type="checkbox" /> Third option-->
                                                <!--</label>-->
                                            <!--</li>-->
                                            <!--<li>-->
                                                <!--<label>-->
                                                    <!--<input type="checkbox" /> Forth option-->
                                                <!--</label>-->
                                            <!--</li>-->
                                            <li role="separator" class="divider" v-if="getUserPlaylists"></li>
                                            <li><label style="color:#f0617d">Create new playlist</label></li>
                                            <li><label>  <input type="text" class="form-control" v-model="newPlaylistName" />
                                                <i class="fa fa-plus-circle" @click="addNewPlayList" title="Insert New Playlist"></i>

                                            </label> </li>
                                        </ul>
                                        <div class="backdropformenu"  @click="hidePlaylistMenu(video.mediaid)"></div>
                                    </div>
                                    <hr>
                                    <p class="right-heart-icon">
                                        <a href="javascript:" @click="setVideoStatus(video)" title ="Remove Video?">
                                            <i class="fa fa-2x fa-heart-o activeIcons"  v-bind:style="{ color: getCorpHeaderColor}"
                                              aria-hidden="true" ></i></a>
                                    </p>
                                </div>
                            </div>
                            <div v-if="getAuthUserFavVideos && getAuthUserFavVideos.length == 0">
                                <h1 class="favesText" text-center text-muted margin-bottom-40>Your faves folder is empty. Start saving your bite-sized collection today by clicking the <span><i class="fa fa-x fa-heart-o" aria-hidden="true"/></span> after watching a clip you love</h1>
                            </div>
                        </div>
                    </div>
                    <div class="tabContent" id="tabs-2" :class="{ current: tabs.playlist }">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-3">
                                    <h3>{{personalPlaylistTitle}}</h3>
                                </div>
                                <div class="col-md-9">
                                    <div class="row yourFaves" v-if="userPersonalPlaylists">
                                        <div class="col-xs-12 col-sm-6 col-md-4 bottom-margin" :class="{'innerimggray': getTrialDays < 0}" v-for = "playlist in userPersonalPlaylists" v-if="playlist.userPlaylistVideos">
                                            <div >
                                                <div class="viderowraper" :class="{'innerimggray': getTrialDays < 0}"> <div class="favnumbers" v-bind:style="{ backgroundColor: getCorpHeaderColor}"><div><span>{{playlist.allVidDurInMinutes}}</span><small>mins</small></div><i title="Play" class="fa fa-play-circle-o" @click="playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode)"></i> <i title="Remove" class="fa fa-trash" @click="removePlaylist(playlist.playlistId)"></i><i v-if="playlist.haveCorporationVideo === 0 && ((user && user.corporation === null) || (user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.sharePersonalPlaylistPermission >= 1))" title="Share Playlist" class="fa fa-share-square-o" @click="showSharingModal(playlist, 'personal')"></i><i v-if="playlist.haveCorporationVideo === 1" title="This playlist contains videos which are private and cannot be shared" class="fa fa-share-square-o" @click="showPrivateVideoShareMsg()"></i></div>
                                                    <img class="jw-img" :src="playlist.userPlaylistVideos[0].thumbnailURL" @click="playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode)" :alt="playlist.title" :title="playlist.title" /></div>
                                                <p class="text-wrap-title cursor" @click="playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode)"> {{playlist.title}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <h1 class="favesText" text-center text-muted margin-bottom-40>Your personal playlists folder is empty. Start saving your video collection today by clicking the <span>
<!--                                            <img src="../assets/playlist-icon.png" class="menuiconbutton" alt="PLAYLIST" title="Playlist"/>-->
                                                                                       <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                                                            width="37px" height="24px" viewBox="0 0 37 24" enable-background="new 0 0 37 24" xml:space="preserve">
<rect y="0.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                    <rect y="8.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                    <rect y="17.2" :fill="getCorpHeaderColor" width="18.2" height="3"/>
                                                    <rect x="23" y="15.2" :fill="getCorpHeaderColor" width="14" height="4"/>
                                                    <rect x="27.958" y="10.242" :fill="getCorpHeaderColor" width="4" height="13.917"/>
</svg>
                                        </span> icon next to any video to create your first playlist</h1>
                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <div class="row" v-if="userCorpSharedPlaylists">
                                <div class="col-md-3">
                                    <h3 v-if="user.corporation.playlistHeading">{{user.corporation.playlistHeading}}</h3> <h3 v-else>{{corpPlaylistTitle}}</h3>
                                </div>
                                <div class="col-md-9">
                                    <div class="row yourFaves" v-if="userCorpSharedPlaylists">
                                        <div class="col-xs-12 col-sm-6 col-md-4 bottom-margin" :class="{'innerimggray': getTrialDays < 0}" v-for = "playlist in userCorpSharedPlaylists" v-if="playlist.userPlaylistVideos">
                                            <div >
                                                <div class="viderowraper" :class="{'innerimggray': getTrialDays < 0}"> <div class="favnumbers" v-bind:style="{ backgroundColor: getCorpHeaderColor}"><div><span>{{playlist.allVidDurInMinutes}}</span><small>mins</small></div><i title="Play" class="fa fa-play-circle-o" @click="playCorpPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)"></i><i v-if="((user && user.corporation === null) || (user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.corpPlaylistShareOptnPermission >= 1))" title="Share Playlist" class="fa fa-share-square-o" @click="showSharingModal(playlist, 'corporate')"></i><i v-if="playlist.haveCorporationVideo === 1" title="This playlist contains videos which are private and cannot be shared" class="fa fa-share-square-o" @click="showPrivateVideoShareMsg()"></i></div>
                                                    <img class="jw-img" :src="playlist.userPlaylistVideos[0].thumbnailURL" @click="playCorpPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)" :alt="playlist.title" :title="playlist.title" /></div>
                                                <p class="text-wrap-title cursor" @click="playCorpPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)"> {{playlist.title}}</p>
                                            </div>
                                        </div>
<!--                                        <i title="Share Playlist" class="fa fa-share-square-o" @click="openCorporateShareModal(playlist)"></i>-->
                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <div class="row" v-if="userCuratedPlaylists" :class="{ hidden: isHidden() }">
                                <div class="col-md-3">
                                    <h3>{{trendingPlaylistTitle}}</h3>
                                </div>
                                <div class="col-md-9">
                                    <div class="row yourFaves" v-if="userCuratedPlaylists">
                                        <div class="col-xs-12 col-sm-6 col-md-4 bottom-margin" :class="{'innerimggray': getTrialDays < 0}" v-for = "playlist in userCuratedPlaylists" v-if="playlist.userPlaylistVideos">
                                            <div >
                                                <div class="viderowraper" :class="{'innerimggray': getTrialDays < 0}"> <div class="favnumbers" v-bind:style="{ backgroundColor: getCorpHeaderColor}"><div><span>{{playlist.allVidDurInMinutes}}<small>mins</small></span></div><i title="Play" class="fa fa-play-circle-o" @click="playTrendingPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)"></i><i v-if="playlist.haveCorporationVideo === 0 && ((user && user.corporation === null) || (user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.shareTrendingPlaylistPermission >= 1))" title="Share Playlist" class="fa fa-share-square-o" @click="showSharingModal(playlist, 'trending')"></i><i v-if="playlist.haveCorporationVideo === 1" title="This playlist contains videos which are private and cannot be shared" class="fa fa-share-square-o" @click="showPrivateVideoShareMsg()"></i></div>
                                                    <img class="jw-img" :src="playlist.userPlaylistVideos[0].thumbnailURL" @click="playTrendingPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)" :alt="playlist.title" :title="playlist.title" /></div>
                                                <p class="text-wrap-title cursor" @click="playTrendingPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)"> {{playlist.title}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <!--////////////////////// first box end here //////////////////////////-->
                    <!--////////////////////// second box start here ///////////////////////-->
                    <div class="tabContent" id="tabs-3" :class="{ current: tabs.chat }">
                        <div class="container personalize">
                            <div class="row">
                                <div class="col-md-12">
                                    <p class="personalizeText">
                                       As part of your membership, TONE delivers two, short videos chosen specifically for you based on your selected preferences.
                                       Tell us what you like and we’ll send you more of the content you love!
                                    </p>
                                </div>


                                <div class="col-md-12  interestlist">

                                    <div>
                                        <div class="col-md-7 box-size">
                                            <div class="main-content text-left pt-3">
                                                <hr>
                                                <h2 class="profile-heading">
                                                Topics Of Interest:
                                                </h2>
                                            </div>
                                        </div>
                                        <div class="interest-container" v-if="getAllInterests && getUserInterests">
                                            <button-group v-model="interestIndexes">
                                                <span v-for="(interest, interestId) in getAllInterests">
                                                    <span>
                                                        <checkbox class="min-padding checkbox-btn" :key="interestId" :true-value="interestId" v-bind:style="styleInterestObject(interestId)">
                                                            {{interest.interestName}}
                                                        </checkbox>
                                                    </span>
                                                </span>
                                                <button v-if="getAllInterests" class="min-padding checkbox-btn" v-bind:style="[toggleStatus ? { color: '#FFFFFF !important', backgroundColor: this.getCorpButtonColor + ' !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important', 'outline': 'none'} : { color: getCorpButtonColor + '!important', backgroundColor: '#FFFFFF !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important', 'outline': 'none'}]"  type="button" @click="toggleStatus = !toggleStatus"><i class="fa fa-gift fa-2x" aria-hidden="true"></i> I want it all!</button>
                                                <!--<button v-if="getAllInterests" class="min-padding checkbox-btn" type="button" @click="checkAllInterests()"><i class="fa fa-gift fa-2x" aria-hidden="true"></i> I want it all!</button>-->
                                            </button-group>
                                        </div>
                                    </div>
                                    <div>
                                        <div>
                                            <div class="headerlevel3 text-left"><h3 class="profile-heading">TONE Teaser Delivery Days (choose at least two days):</h3></div>
                                            <div class="interest-container" style="margin: 0;">
                                                <button-group v-model="selectedDays"  style="margin: 25px">
                                                    <span v-for="(day, index) in daysOfWeek">
                                                        <span>
                                                            <checkbox class="min-padding checkbox-btn-days" :key="index" :true-value="index" v-bind:style="styleDays(index)">
                                                                {{day}}
                                                            </checkbox>
                                                        </span>
                                                    </span>
                                                </button-group>
                                            </div>
                                        </div>
                                    </div>
                                    <button v-bind:style="{ backgroundColor: getCorpButtonColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important', 'outline': 'none'}" type="button" class="updateInterest" @click="updateInterests()" :disabled = "interestIndexes.length == 0">
                                        UPDATE
                                        <spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <!--//////////////////////////-->

                    </div>
                    <!--////////////////////// second box end here /////////////////////////-->
                    <!--////////////////////// third box start here ////////////////////////-->
                    <div class="tabContent" id="tabs-4" :class="{ current: tabs.discussion }">
                        <div class="container">
                            <h3 class="pinkh3"  v-if="(getCardExpiryDays < 0 && user.ccExpAlarmFlag === 2)">You payment method has expired. Please update your information to access your TONE account.</h3>
                            <h3 class="pinkh3"  v-if="(user.ccExpAlarmFlag === 2 && (getCardExpiryDays > 0 && getCardExpiryDays < 5)) && user.ccExpiryDate">You payment method is expiring in {{getCardExpiryDays}} <span v-if="getCardExpiryDays > 1">days.</span><span v-else>day.</span> Please update your information to access your TONE account.</h3>
                            <div class="row accountContentBox">
                                <div class="col-xs-12 col-sm-6 col-md-6">
                                    <div class="accountLeft">
<!--                                        <img v-if="!user.picture" src="../assets/account_circle.png" alt="USER-SHOE">-->
                                        <span v-if="user && user.corporation && user.corporation.showShoeMotif === 2">
                                            <img v-if="user.picture" src="https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile.png" alt="USER-PROFILE" title="Profile Image">
                                        </span>
                                        <span v-else>
                                            <img v-if="user.picture" v-bind:src="getRelatedImage(user.picture)" alt="USER-SHOE" title="Profile Image">
                                        </span>
<!--                                        <img v-if="user.picture" v-bind:src="getRelatedImage(user.picture)" alt="USER-SHOE" title="Profile Image">-->
                                        Profile Image
                                    </div>
                                    <hr />
                                    <span v-if="user && user.corporation && user.corporation.showShoeMotif === 2">
                                    </span>
                                    <span v-else>
                                         <h3 v-if="imageText" v-html="imageText">
                                        <!--So many shoes to fill and only two feet! Step into our community of women helping women by selecting your first pair of shoes. By the way, you can change your style as often as you like!-->
                                    </h3>
                                    <div class="slider responsive-slick-imagelist" v-if="getDefaultImages">
                                        <div v-for = "getDefaultImage in getDefaultImages">
                                            <div class="slide-player">
                                                <img class="jw-img" :src="getDefaultImage.smallImgUrl" @click="setDefaultImage(getDefaultImage)" :alt="getDefaultImage.title" :title="getDefaultImage.title" />
                                                <!-- p class="text-wrap-title">
                                                    {{getDefaultImage.title}}
                                                </p -->
                                                <hr>
                                                <button v-bind:style="{ backgroundColor: getCorpHeaderColor}"  @click="setDefaultImage(getDefaultImage)" class="carousalbutton" v-if="user.picture !== getDefaultImage.smallImgUrl">
                                                    Select
                                                </button>
                                                <button diabled class="carousalbutton selected" v-if="user.picture === getDefaultImage.smallImgUrl">
                                                    <i class="fa fa-check"></i> Selected
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    </span>

                            </div>
                                <div class="col-xs-12 col-sm-6 col-md-6">
                                    <!-- button v-if="user && (user.corporation && user.corporation.enableCorporatePage === 1)"  v-bind:style="{ backgroundColor: getCorpButtonColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}" class="btn formButton btn-block" type="button"  @click="$router.push('corporation/mycommunity')">Enter My Community Page
                                    </button -->
                                    <a style="cursor: pointer;" v-if="user && (user.corporation && user.corporation.pageAdmin === user.userId)"  @click="$router.push('/corporation/manage-page')"><h4>Manage Custom Features</h4></a>
                                    <div class="accountRight">
                                        <!--<a href="javascript:" class="needHelp">Need Help?</a>-->
                                        <form>
                                            <div class="formName">
                                                <h4>Name: <a @click="showUpdateName" :class="{ hidden: showUpdateNameBox }" href="javascript:">update</a></h4>
                                                <h5>{{user.firstName}} {{user.lastName}} </h5>
                                                <form class="updateName" :class="{ hidden: !showUpdateNameBox }" v-on:submit.prevent="onNameSubmit()">
                                                    <bs-input v-model="updatedFirstName"
                                                              id = "profile_updatedfirstname"
                                                              type="text"
                                                              class="form-input"
                                                              placeholder="First Name"
                                                              required
                                                              icon>
                                                    </bs-input>
                                                    <bs-input v-model="updatedLastName"
                                                              id = "profile_updatedlastname"
                                                              type="text"
                                                              class="form-input"
                                                              placeholder="Last Name"
                                                              required
                                                              icon>
                                                    </bs-input>
                                                    <a @click="showUpdateName" href="javascript:">Cancel</a>
                                                    <button type="submit" id="profile_updatename" :disabled="spinner" v-bind:style="{ backgroundColor: getCorpButtonColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}">Update
                                                        <spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>
                                                    </button>
                                                </form>
                                            </div>
                                            <!-- <div class="formName" v-if="showMobFlag()">
                                                <h4>Mobile Number: <a @click="showUpdateMobile" :class="{ hidden: showUpdateMobileBox }" href="javascript:">update</a></h4>
                                                <h5>{{user.phoneNumber}}</h5>
                                                <form class="updateName" :class="{ hidden: !showUpdateMobileBox }" v-on:submit.prevent="onMobileSubmit()">
                                                    <div class="form-group">
                                                        <masked-input v-model="phoneNumber" @input="rawPhoneNumber = arguments[1]"
                                                                      class="input form-control"
                                                                      error="Mobile Number"
                                                                      placeholder="New Mobile Number"
                                                                      mask="\(111) 111-1111"
                                                        >
                                                        </masked-input>
                                                    </div>
                                                    <a @click="showUpdateMobile" href="javascript:">Cancel</a>
                                                    <button type="submit" id="profile_updateMobile" :disabled="spinner" v-bind:style="{ backgroundColor: getCorpButtonColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}">Update
                                                        <spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>
                                                    </button>
                                                </form>
                                            </div> -->
                                            <!-- <div class="formName" v-if="showDOBFlag()">
                                                <h4>Birthday: <a @click="showUpdateDOB" :class="{ hidden: showUpdateDOBBox }" href="javascript:">update</a></h4>
                                                <h5>{{user.dob}}</h5>
                                                <form class="updateName" :class="{ hidden: !showUpdateDOBBox }" v-on:submit.prevent="onDOBSubmit">
                                                    <bs-input v-model="updatedDOB"
                                                              id = "profileDOB"
                                                              type="date"
                                                              class="form-input"
                                                              placeholder="new date of birth"
                                                              data-date-format='mm/dd/yyyy'
                                                              icon>
                                                    </bs-input>

                                                    <a @click="showUpdateDOB" href="javascript:">Cancel</a>
                                                    <button type="submit" id="profile_updatedob" :disabled="spinner" v-bind:style="{ backgroundColor: getCorpButtonColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}">Update
                                                        <spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>
                                                    </button>
                                                </form>
                                            </div> -->
                                            <div class="formName">
                                                <div v-if="user.status.toLowerCase() ==='register' || user.status.toLowerCase() ==='registered'">
                                                    <h3 class="alert alert-info">Your new email account needs to be validated. <br> Check your email and follow the link</h3>
                                                </div>
                                                <div v-else>
                                                    <h4>Email: <a @click="showUpdateEmail" :class="{ hidden: showUpdateEmailBox || isHidden() }" href="javascript:">change</a></h4>
                                                    <h5>{{user.email}}</h5>
                                                    <form class="updateName" :class="{ hidden: !showUpdateEmailBox }" v-on:submit.prevent="onEmailChangeSubmit">
                                                        <bs-input v-model="oldPasswordForEmail"
                                                                  id = "profile_oldEmail"
                                                                  type="password"
                                                                  class="form-input"
                                                                  placeholder="Password"
                                                                  required
                                                        >
                                                        </bs-input>
                                                        <bs-input v-model="newEmail"
                                                                  v-bind:pattern="/\S+@\S+\.\S+/"
                                                                  id = "profile_new_email"
                                                                  type="email"
                                                                  class="form-input"
                                                                  error="Email Address"
                                                                  placeholder="New Email Address"
                                                                  name="email"
                                                                  required
                                                                  icon>
                                                        </bs-input>
                                                        <a @click="showUpdateEmail" href="javascript:">Cancel</a>
                                                        <button type="submit" id="profile_updateEmail" :disabled="spinner" v-bind:style="{ backgroundColor: getCorpButtonColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}">Update
                                                            <spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>
                                                        </button>
                                                    </form>
                                                </div>
                                            </div>
                                            <div class="formName" :class="{ hidden: isHidden() }">
                                                <h4>Password: <a @click="showUpdatePassword" :class="{ hidden: showUpdatePasswordBox }" href="javascript:">change</a></h4>
                                                <h5>******************</h5>
                                                <form class="updateName" :class="{ hidden: !showUpdatePasswordBox }" v-on:submit.prevent="onPasswordSubmit">
                                                    <bs-input v-model="oldPassword"
                                                              id = "profile_oldpassword"
                                                              type="password"
                                                              class="form-input"
                                                              placeholder="Old Password"
                                                              required
                                                              icon>
                                                    </bs-input>
                                                    <bs-input v-model="updatedPassword" :minlength="6"
                                                              id = "profile_newpassword"
                                                              error="Password is Required"
                                                              type="password"
                                                              class="form-input"
                                                              placeholder="Password"
                                                              required
                                                              icon>
                                                    </bs-input>
                                                    <bs-input v-model="confirmPassword" :minlength="6"
                                                              id = "profile_confirmPassword"
                                                              error="Confirm Password is Required"
                                                              type="password"
                                                              class="form-input"
                                                              placeholder="Confirm Password"
                                                              required
                                                              icon>
                                                    </bs-input>
                                                    <a @click="showUpdatePassword" href="javascript:">Cancel</a>
                                                    <button type="submit" id="profile_updatepassword" :disabled="spinner" v-bind:style="{ backgroundColor: getCorpButtonColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}">Update
                                                        <spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>
                                                    </button>
                                                </form>
                                                <alert v-show="!verifyPassword()" placement="top" duration="2000" type="danger" width="400px" dismissable>
                                                    <span class="icon-info-circled alert-icon-float-left"></span>
                                                    <strong>Error:</strong>
                                                    <p id="profile_pwderrormsg">{{passwordError}}</p>
                                                </alert>
                                            </div>
                                            <!-- div class="formName" v-if="getProfileCharitySection">
                                                <h4>Selected Charity: <a v-show="!isCharityUpdate" href="javascript:"
                                                                         @click="isCharityUpdate = true">update</a></h4>
                                                <div v-if="getSelectedCharity && getSelectedCharity !== '{}'">
                                                    <img :src="getSelectedCharity.img_url" alt="Selected Charity" :title="getSelectedCharity.name">
                                                    <span class="SelectedCharityName">{{getSelectedCharity.name}}</span>
                                                </div>
                                                <form v-show="isCharityUpdate" class="updateName selectedCharityBtn"
                                                      v-on:submit.prevent="updateCharity">
                                                    <a href="javascript:" @click="isCharityUpdate = false">Cancel</a>
                                                    <button type="submit" id="" v-bind:style="{ backgroundColor: getCorpButtonColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}">Update
                                                        <spinner size="lg" class="btn-spinner"></spinner>
                                                    </button>
                                                </form>
                                            </div -->
                                            <div class="formName" v-if="!getAlertMsgStatus" :class="{ highlight: (getCardExpiryDays < 5 && user.ccExpAlarmFlag === 2)}">
                                                <h4 id="updatepaymentmethod">Payment Method:<a @click="showUpdatePayment" :class="{ hidden: showPaymentBox }" href="javascript:">change</a></h4>
                                                <div class="row notstripes" v-if="!isStripe">
                                                    <div class="col-md-12" >
                                                        <h5 v-if="!isStripe">PayPal</h5>
                                                        <div id="paypal-button" class="text-center margin-top-10 margin-bottom-10"></div>
                                                        <span  class="icon-info-circled alert-icon-float-left success" v-if="userPayments.paymentMethodNonce">
                                                        <p class="alert alert-success alert-dismissable" ><i class="fa fa-check-square-o" aria-hidden="true"></i>Payment successfully authorized with Paypal</p>
                                                        </span>
                                                        <!--<div id="dropin-container"></div>-->
                                                        <!--<button id="submit-button">Request payment method</button>-->
                                                    </div>
                                                </div>
                                                <h5 class="paymentmethodh5" v-if="isStripe && getCreditCardInfo">{{getCreditCardInfo}}</h5>
                                                <!--<h5 v-if="isStripe">VISA &#45;&#45; 4242</h5>-->
                                                <h6><a @click="showPaymentHistory" :class="{ hidden: showPaymentHistoryBox }" href="javascript:">View Billing History</a></h6>
                                                <form action="/charge" method="post" id="payment-form" class="updateName" :class="{ hidden: !showPaymentBox }" v-on:submit.prevent="onNewCardSubmit">
                                                    <div id="card-element" class="field" v-if="isStripe"></div>
                                                    <!-- Used to display form errors -->
                                                    <div id="card-errors" role="alert"></div>
                                                    <br/>
                                                    <a @click="showUpdatePayment" href="javascript:">Cancel</a>
                                                    <button type="submit" id="profile_changecc" :disabled="showPaymentHistoryBox" v-bind:style="{ backgroundColor: getCorpHeaderColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}">Update
                                                        <spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>
                                                    </button>
                                                </form>
                                                <div v-if="showPaymentHistoryBox">
                                                    <br/>
                                                <h5>Billing History</h5>
                                                    <br/>
                                                    <br/>
                                                    <div v-if="getBillingHistory">
                                                    <table class='table table--lg team-roster-table table-hover' v-if="getBillingHistory">
                                                        <thead>
                                                        <th>Date</th>
                                                        <th>Description</th>
                                                        <th>Amount</th>
                                                        </thead>
                                                        <tbody>
                                                        <tr v-for="record in getBillingHistory" >
                                                            <td style="text-align: left">{{record.paymentDateFmt}}</td>
                                                            <td style="text-align: left">{{record.paymentType}}</td>
                                                            <td style="text-align: left">${{record.paidAmountFmt}}</td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                    </div>
                                                    <div v-else>
                                                        <h6 style="text-align: center">No record to display!</h6>
                                                    </div>
                                                    <a @click="showPaymentHistory" href="javascript:">Hide Billing History</a>
                                                </div>
                                            </div>
                                            <div class="formName"  v-if="getAlertMsgStatus && getTrialDays <= 30 && (user && user.corporation === null || user && user.corporation && user.corporation.trialExpiryMsgFlag)">
                                                <a @click="$router.push('/becomemember')" href="javascript:"><strong>{{expiredTrialMessage}}</strong></a>
                                            </div>
                                            <!--<div class="formName">-->
                                                <!--<h5>Privacy & Settings:</h5>-->
                                                <!--<p>-->
                                                    <!--<a href="javascript:">This is a placeholder link</a>-->
                                                    <!--<a href="javascript:">This is a placeholder link</a>-->
                                                <!--</p>-->
                                                <!--<p>-->
                                                    <!--<a href="javascript:">This is a link</a>-->
                                                    <!--<a href="javascript:">This is a link</a>-->
                                                <!--</p>-->
                                                <!--<p>-->
                                                    <!--<a href="javascript:">This is a placeholder link</a>-->
                                                    <!--<a href="javascript:">This is a placeholder link</a>-->
                                                <!--</p>-->
                                            <!--</div>-->
                                            <div class="formName" :class="{ hidden: isHidden() }">
                                                <div v-if="user.status ==='CANCELLED'">
                                                    <h3 class="alert alert-danger">Request for Cancellation has been sent. Check your email for confirmation</h3>
                                                </div>
                                                <div v-else>
                                                    <h4><a href="javascript:" @click="cancelSubscription()">cancel</a></h4>
                                                    <h5>Cancel Your Subscription</h5>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--////////////////////// third box end here //////////////////////////-->
                </div>
            </div>
        </div>
        <modal v-if="showSharedModal" class="watchVideoModal" effect="zoom" :value="showSharedModal" @cancel="cancelModal()">
            <div slot="modal-header" class="watchVideoModalHeader">
                <a href="javascript:">
                    <img src="../assets/logo.svg" alt="LOGO">
                </a>
                <a href="javascript:" @click="cancelModal()">
                    <img class="watchVideoArrow" src="../assets/watch-video-arrow.png" alt="CLOSE">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">
                <div class="form">
                    <form method="post" id="playlistshare-form" v-on:submit.prevent="onSharePlaylist" autocomplete="off">
<!--                        <bs-input v-model="sharePayload.sharedEmailList"-->
<!--                                  name="playlistshare_emaillist"-->
<!--                                  id = "playlistshare_emaillist"-->
<!--                                  v-bind:pattern="/^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/"-->
<!--                                  type="text"-->
<!--                                  class="form-input"-->
<!--                                  error="To Emails (comma separated)"-->
<!--                                  placeholder="To Emails (comma separated)"-->
<!--                                  autocomplete="off"-->
<!--                                  required-->
<!--                                  >-->
<!--                        </bs-input>-->
                        <multiselect v-model="taggedEmails" style="padding-bottom: 10px;"
                                     tag-placeholder="Add this as new email address"
                                     placeholder="Search or add an email address"
                                     label="name"
                                     track-by="name"
                                     :options="emailList"
                                     :multiple="true"
                                     :taggable="true"
                                     @tag="addTag"></multiselect>
                        <bs-input v-model="sharePayload.sharedEmailMessage"
                                  name="playlistshare_sharedMessage"
                                  id = "playlistshare_sharedMessage"
                                  type="text"
                                  class="form-input"
                                  error="Optional Message"
                                  placeholder="Optional Message"
                                  autocomplete="off"
                                  icon>
                        </bs-input>
                        <bs-input v-model="sharePayload.sharedPlaylistPreview"
                                  name="playlistshare_sharedEmailMessagePreview"
                                  id="playlistshare_sharedEmailMessagePreview"
                                  type="textarea"
                                  disabled
                                  class="form-input"
                                  placeholder=""
                        >
                        </bs-input>
                            <button type="submit"  class="btn formButton btn-block" :disabled="spinner ||(taggedEmails && taggedEmails.length === 0)">
                                Send Email
                                <spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>
                            </button>
                    </form>
                </div>
            </div>
            <div slot="modal-footer">
            </div>
        </modal>
        <modal v-if="showCorporateShare" class="watchVideoModal sharesmallpink" effect="zoom" :value="showCorporateShare" @cancel="cancelCorporateModal()">
            <div slot="modal-header" class="watchVideoModalHeader" v-bind:style="{ backgroundColor: getCorpHeaderColor}">
                <i class="fa fa-share-square-o"></i> Share with your Corporate Community Or Friends
                <a href="javascript:" @click="cancelCorporateModal()">
                    <img class="watchVideoArrow" src="../assets/watch-video-arrow.png" alt="CLOSE">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">
                <div class="row">
                    <div class="col-sm-4">
                        <select v-model="shareOption" class="form-control strongselec">
                            <option value="Corporate" v-if="showShareCommunity">Share with Community</option>
                            <option value="Individual" v-if="showShareIndividual">Share with Colleagues</option>
                            <option value="Friends" v-if="showShareFriends">Share with Friends</option>
                        </select>
                    </div>
                    <div class="col-sm-12"  v-if="shareOption === 'Individual'">
                        <div class="clearfix" style="height: 20px;"></div>
                        <multiselect v-if="shareOption === 'Individual'"
                                     v-model="selectedCorps"
                                     :options="allCorps"
                                     :multiple="true"
                                     :taggable="true"
                                     track-by="userId"
                                     :custom-label="customLabel">
                        </multiselect>
                    </div>
                    <div class="col-sm-12"  v-if="shareOption === 'Friends'">
                        <div class="clearfix" style="height: 20px;"></div>
                        <multiselect v-model="taggedEmails" style="padding-bottom: 10px;"
                                     tag-placeholder="Add this as new email address"
                                     placeholder="Search or add an email address"
                                     label="name"
                                     track-by="name"
                                     :options="emailList"
                                     :multiple="true"
                                     :taggable="true"
                                     @tag="addTag"></multiselect>
                    </div>
                </div>
                <hr>
                <div class="usernamenimg text-left">
                    <table>
                        <tr>
                            <td>
                                <img v-bind:src="user && user.corporation && user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : user.picture" alt="user">&nbsp;&nbsp; <b>{{user.firstName.toLowerCase()}}</b>
                            </td>
                            <!--                            <td>-->
                            <!--                                <b>{{user.firstName.toLowerCase()}}</b>-->
                            <!--                            </td>-->
                        </tr>
                    </table>
                </div>
                <div class="clearfix"></div>
                <div class="clearfix"></div>
                <div class="clearfix"></div>
                <textarea v-model="corporateShareMessage"
                          type="textarea"
                          class="form-input form-control"
                          placeholder="Type your message"
                />
                <div class="clearfix" style="height: 30px;"></div>
                <div class="row sharefb">
                    <div class="col-sm-5 col-xs-5">
                        <img :src="corpShareModalImage" :alt="corpShareModalTitle" :title="corpShareModalTitle">
                    </div>
                    <div class="col-sm-7 col-xs-7">
                        <h6>WWW.TONENETWORKS.COM</h6>
                        <h4>{{`${corpShareModalTitle} | TONE Networks`}}</h4>
                        <p v-if="corpShareModalDesc"> {{`${corpShareModalDesc.substring(0,250)}...`}}</p>
                        <p v-if="!corpShareModalDesc">{{user.firstName}}'s Personal Playlist</p>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="row buttonsinpopup">
                    <div class="col-sm-3 col-xs-4">
                        <button class="btn btn-default" @click="cancelCorporateModal()">
                            Cancel
                        </button>
                    </div>
                    <div class="col-sm-9 col-xs-8">
                        <button  v-bind:style="{ backgroundColor: getCorpButtonColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}" class="btn btn-primary btn-pink" :disabled="(shareOption === 'Individual' && (selectedCorps === null || selectedCorps.length === 0 || shareInProcess)) || (shareOption === 'Friends' && (taggedEmails === null || taggedEmails.length === 0 || shareInProcess)) || (shareInProcess)" @click="shareCorporateVideo()">
                            Share This Playlist
                            <spinner v-model="shareInProcess" size="lg" class="btn-spinner"></spinner>
                        </button>
                    </div>
                </div>
                <div class="alert alert-default showmobile">
                    You are sharing as {{`${user.firstName} ${user.lastName}`}}
                </div>
            </div>
            <div slot="modal-footer"></div>
        </modal>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {input, checkbox, buttonGroup, spinner, alert, datepicker, modal} from 'vue-strap'
    import slick from 'slick-carousel'
    import $ from 'jquery'
    import store from '../store'
    import MaskedInput from 'vue-masked-input'
    export default {
        spinner: false,
        components: {
            'bs-input': input,
            'checkbox': checkbox,
            'button-group': buttonGroup,
            'spinner': spinner,
            'masked-input': MaskedInput,
            alert,
            datepicker,
            modal
        },
        name: 'profile',
        metaInfo () {
            let self = this
            return {
                title: self.metaTag_pageTitle ? self.metaTag_pageTitle : 'TONE | Profile',
                meta: [
                    {name: 'keywords', content: self.metaTag_keywords},
                    {name: 'description', content: self.metaTag_description},
                    {property: 'og:image', content: self.metaTag_fb_image},
                    {property: 'og:title', content: self.metaTag_fb_title},
                    {property: 'og:site_name', content: self.metaTag_fb_sitename},
                    {
                        property: 'og:description',
                        content: self.metaTag_fb_description
                    },
                    {property: 'twitter:title', content: self.metaTag_tw_title},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: self.metaTag_tw_image},
                    {
                        property: 'twitter:description',
                        content: self.metaTag_tw_description
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                daysOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
                selectedDays: [],
                hoverState: false,
                interestSelected: false,
                corpShareModalTitle: '',
                corpShareModalDesc: '',
                selectedCorps: [],
                allCorps: [],
                shareInProcess: false,
                shareOption: 'Corporate',
                showShareCommunity: false,
                showShareIndividual: false,
                showShareFriends: false,
                sharePlaylistType: '',
                taggedEmails: [],
                emailList: [],
                eventURL: 'https://www1.dev-tonenetworks.com',
                isPlaylistWatched: false,
                isSectionWatched: true,
                upcomingProfileEvent: null,
                expandPlaylistPanel: false,
                expandTakeawayPanel: false,
                expandEventsAttendedPanel: false,
                expandVideosWatchedPanel: false,
                sharedPlaylistId: 0,
                sharedPlaylistTitle: '',
                sharedEmailList: '',
                sharedEmailMessage: '',
                sharedPlaylistPreview: '',
                showSharedModal: false,
                isStripe: true,
                toggleStatus: false,
                isCharityUpdate: false,
                passwordError: '',
                updatedFirstName: '',
                updatedLastName: '',
                showUpdateNameBox: false,
                showUpdateMobileBox: false,
                phoneNumber: '',
                rawPhoneNumber: '',
                updatedDOB: '',
                showUpdateDOBBox: false,
                oldPassword: '',
                oldPasswordForEmail: '',
                newEmail: '',
                updatedPassword: '',
                confirmPassword: '',
                showUpdatePasswordBox: false,
                showUpdateEmailBox: false,
                showPaymentBox: false,
                showPaymentHistoryBox: false,
                interestIndexes: [],
                userInterests: [],
                spinner: false,
                success: false,
                sucessMsg: '',
                alert: false,
                stripe: '',
                clearButton: true,
                newPlaylistName: '',
                playlistHasVideo: false,
                card: '',
                isMobileSubscribe: false,
                isPushNotificationSubscribe: false,
                tabs: {
                    videos: false,
                    playlist: false,
                    chat: false,
                    coolFeatures: false,
                    discussion: true
                },
                userPaymentsCol: [],
                userPayments: {
                    token: '',
                    stripeCardId: '',
                    paymentType: 'CC',
                    paymentDate: new Date(),
                    paypalPayerId: '',
                    paypalPaymentId: '',
                    paymentMethodNonce: ''
                },
                sharePayload: {
                    sharedPlaylistId: 0,
                    sharedPlaylistTitle: '',
                    sharedEmailList: '',
                    sharedEmailMessage: '',
                    sharedPlaylistPreview: ''
                },
                shareVideoPayload: {
                    corporationId: 0,
                    senderUserId: 0,
                    recipientsUserIds: [],
                    recipientFriendEmails: null,
                    playlistId: '',
                    messageText: '',
                    playlistType: 0
                },
                videoAdded: false,
                videoRemoved: false,
                selectedVideo: 0,
                selecedPlaylist: 0,
                failedEmail: '',
                showCorporateShare: false,
                previewMsg: 'Message Preview: \n',
                expiredTrialMessage: '',
                imageText: 'So many shoes to fill and only two feet! Step into our community by selecting your first pair of shoes. By the way, you can change your style as often as you like!',
                // coolFeature1Title: 'TONE Takeaways',
                // coolFeature1Desc: 'We know you’re busy! That’s why we send TONE Takeaways: executive summaries of the videos you’ve watched with all the reminders and tips you need to take action on what you’ve learned.',
                // coolFeature2Title: 'TONE Teasers',
                // coolFeature2Desc: 'Get custom content based on your interests with TONE Teasers: suggested videos we think you’ll love delivered right to your inbox twice a week! These reminders are designed to tease you away from your busy life and take a moment for yourself.',
                // coolFeature3Title: 'TONE on Your Phone',
                // coolFeature3Desc: 'Get TONE on your phone! Our upcoming app gives you access to everything TONE. If an app isn’t your thing, you’ll also have the option of having your teasers and takeaways sent to you by text. Think of it as TONE in the palm of your hand.',
                // coolFeature4Title: 'TONE Live',
                // coolFeature4Desc: 'Join live Q&A sessions with our experts on TONE Live, our monthly live streaming events. Ask questions and get answers from our credentialed experts on a number of topics.',
                // coolFeature5Title: 'TONE Talk',
                // coolFeature5Desc: 'Ask questions and share advice with your fellow TONE Members in TONE Talks, our weekly live chat group moderated by one of our experts.',
                // coolFeature6Title: 'Shoe-cognito',
                // coolFeature6Desc: 'Want to step into a new pair of shoes? Join any event in shoe-cognito mode to participate and ask your questions anonymously. We have a number of styles so you can change as you like to suit your mood!',
                // coolFeature7Title: 'Playlists',
                // coolFeature7Desc: 'Make a custom playlist of all the videos you love. Then enjoy all your TONE favorites in one place!',
                // coolFeature8Title: 'Sharing',
                // coolFeature8Desc: 'Know someone who could use some tips from TONE? You can share all our videos with all your friends - even if they’re not members yet.',
                // coolFeature9Title: 'Clicks for Good',
                // coolFeature9Desc: 'We help you give back to your community! The more time you spend on TONE, the more we donate to the TONE Clicks for Good charities.',
                userPersonalPlaylists: null,
                userCuratedPlaylists: null,
                userCorpSharedPlaylists: null,
                userProgressPlaylists: null,
                userProgressEventsAttended: null,
                userProgressVideosWatched: null,
                userProgressTakeaways: null,
                personalPlaylistTitle: 'Your Playlists',
                trendingPlaylistTitle: 'Trending Playlists',
                corpPlaylistTitle: 'Women\'s LINC Playlists',
                progressHeading1: 'Look What YOU\'VE accomplished!',
                progressHeading2: 'Good for you!"',
                progressHeading3: 'Keep Investing in Yourself',
                progressEmptyTakeawayHdng1: '',
                progressEmptyTakeawayHdng2: '',
                progressEmptyTakeawayHdng3: '',
                progressEmptyTakeawayHdng4: '',
                metaTag_pageTitle: '',
                metaTag_description: '',
                metaTag_keywords: '',
                metaTag_fb_image: '',
                metaTag_fb_title: '',
                metaTag_fb_description: '',
                metaTag_fb_sitename: '',
                metaTag_tw_image: '',
                metaTag_tw_title: '',
                metaTag_tw_description: ''
            }
        },
        watch: {
            'sharePayload.sharedEmailMessage' (to, from) {
                let self = this
                // self.sharePayload.sharedPlaylistPreview = `${self.user.firstName} ${self.user.lastName} shared a playlist with you on TONE Networks: \n ${self.sharePayload.sharedPlaylistTitle} \n`
                let oriiginalMessage = `${self.user.firstName} ${self.user.lastName} shared a playlist with you on TONE Networks: \n${self.sharePayload.sharedPlaylistTitle} \n`
                if (self.showSharedModal && (self.sharePayload.sharedEmailMessage && self.sharePayload.sharedEmailMessage.length > 0)) {
                    self.sharePayload.sharedPlaylistPreview = `${self.previewMsg}${oriiginalMessage}${self.sharePayload.sharedEmailMessage}`
                } else {
                    self.sharePayload.sharedPlaylistPreview = `${self.previewMsg}${self.user.firstName} ${self.user.lastName} shared a playlist with you on TONE Networks: \n${self.sharePayload.sharedPlaylistTitle} \n`
                }
            },
            '$route.params.feature' (to, from) {
                let self = this
                if (this.$route.params.feature && this.$route.params.feature.toString().toLowerCase() === 'playlist') {
                    this.switchTab('playlist')
                    self.$store.dispatch('GETDYNAMICCONTENTS', 31).then(() => {
                        if (self.getAllSiteContents) {
                            // Load Meta Tags
                            this.metaTag_pageTitle = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_PAGE_TITLE')
                            this.metaTag_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_DESCRIPTION')
                            this.metaTag_keywords = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_KEYWORDS')
                            // OpenGraph Tags
                            this.metaTag_fb_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE')
                            this.metaTag_fb_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE')
                            this.metaTag_fb_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION')
                            this.metaTag_fb_sitename = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME')
                            // Twitter Tags
                            this.metaTag_tw_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_TITLE')
                            this.metaTag_tw_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE')
                            this.metaTag_tw_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION')
                        }
                    })
                } else if (this.$route.params.feature && this.$route.params.feature.toString().toLowerCase() === 'myprogress') {
                    this.switchTab('coolFeatures')
                    self.$store.dispatch('GETDYNAMICCONTENTS', 32).then(() => {
                        if (self.getAllSiteContents) {
                            // Load Meta Tags
                            this.metaTag_pageTitle = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_PAGE_TITLE')
                            this.metaTag_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_DESCRIPTION')
                            this.metaTag_keywords = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_KEYWORDS')
                            // OpenGraph Tags
                            this.metaTag_fb_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE')
                            this.metaTag_fb_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE')
                            this.metaTag_fb_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION')
                            this.metaTag_fb_sitename = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME')
                            // Twitter Tags
                            this.metaTag_tw_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_TITLE')
                            this.metaTag_tw_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE')
                            this.metaTag_tw_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION')
                        }
                    })
                } else if (this.$route.params.feature && this.$route.params.feature.toString().toLowerCase() === 'personalize') {
                    this.switchTab('chat')
                    self.$store.dispatch('GETDYNAMICCONTENTS', 33).then(() => {
                        if (self.getAllSiteContents) {
                            // Load Meta Tags
                            this.metaTag_pageTitle = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_PAGE_TITLE')
                            this.metaTag_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_DESCRIPTION')
                            this.metaTag_keywords = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_KEYWORDS')
                            // OpenGraph Tags
                            this.metaTag_fb_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE')
                            this.metaTag_fb_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE')
                            this.metaTag_fb_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION')
                            this.metaTag_fb_sitename = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME')
                            // Twitter Tags
                            this.metaTag_tw_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_TITLE')
                            this.metaTag_tw_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE')
                            this.metaTag_tw_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION')
                        }
                    })
                } else if (this.$route.params.feature && this.$route.params.feature.toString().toLowerCase() === 'myfav') {
                    this.switchTab('videos')
                    self.$store.dispatch('GETDYNAMICCONTENTS', 33).then(() => {
                        if (self.getAllSiteContents) {
                            // Load Meta Tags
                            this.metaTag_pageTitle = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_PAGE_TITLE')
                            this.metaTag_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_DESCRIPTION')
                            this.metaTag_keywords = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_KEYWORDS')
                            // OpenGraph Tags
                            this.metaTag_fb_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE')
                            this.metaTag_fb_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE')
                            this.metaTag_fb_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION')
                            this.metaTag_fb_sitename = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME')
                            // Twitter Tags
                            this.metaTag_tw_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_TITLE')
                            this.metaTag_tw_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE')
                            this.metaTag_tw_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION')
                        }
                    })
                } else {
                    this.switchTab('discussion')
                    self.$store.dispatch('GETDYNAMICCONTENTS', 15).then(() => {
                        if (self.getAllSiteContents) {
                            // Load Meta Tags
                            this.metaTag_pageTitle = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_PAGE_TITLE')
                            this.metaTag_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_DESCRIPTION')
                            this.metaTag_keywords = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_KEYWORDS')
                            // OpenGraph Tags
                            this.metaTag_fb_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE')
                            this.metaTag_fb_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE')
                            this.metaTag_fb_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION')
                            this.metaTag_fb_sitename = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME')
                            // Twitter Tags
                            this.metaTag_tw_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_TITLE')
                            this.metaTag_tw_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE')
                            this.metaTag_tw_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION')
                        }
                    })
                    this.$store.dispatch('DEFAULTIMAGESLIST').then(() => {
                        if (this.getDefaultImages) {
                            setTimeout(() => {
                                this.setCarousal()
                            }, 2000)
                        }
                    })
                }
            },
            'toggleStatus' (to, from) {
                let self = this
                if (self.toggleStatus) {
                    self.checkAllInterests()
                } else {
                    self.interestIndexes = []
                }
            },
            'isMobileSubscribe' (to, from) {
                let self = this
                self.spinnerToggle()
                if (self.isMobileSubscribe) {
                    self.user.isOptOutSMS = '1'
                } else {
                    self.user.isOptOutSMS = '0'
                }
                this.$store.dispatch('UPDATEUSERPROFILE', self.user).then(() => {
                    // this.log('updated profile', this.user)
                    self.spinnerToggle()
                })
            },
            'showCorporateShare' (to, from) {
                let self = this
                if (self.showCorporateShare) {
                    self.selectedCorps = null
                    self.corporateShareMessage = ''
                    self.taggedEmails = []
                }
            },
            'shareOption' (to, from) {
                let self = this
                self.selectedCorps = null
                self.corporateShareMessage = ''
                self.taggedEmails = []
            },
            'isPushNotificationSubscribe' (to, from) {
                let self = this
                self.spinnerToggle()
                if (self.isPushNotificationSubscribe) {
                    self.user.isOptOutPn = '1'
                } else {
                    self.user.isOptOutPn = '0'
                }
                this.$store.dispatch('UPDATEUSERPROFILE', self.user).then(() => {
                    // this.log('updated profile', this.user)
                    self.spinnerToggle()
                })
            }
        },
        methods: {
            styleDays (interestId) {
                let isSelected = this.selectedDays.filter(x => {
                    return x.toString() === interestId.toString()
                })
                if (isSelected && isSelected.length > 0) {
                    return {
                        color: '#FFFFFF !important',
                        backgroundColor: this.getCorpButtonColor,
                        borderWidth: '1px !important',
                        borderStyle: 'solid !important',
                        borderColor: this.getCorpButtonColor + ' !important'
                        // border: '2px solid' + this.getCorpButtonColor + ' !important'
                    }
                } else {
                    return {
                        // border: '2px solid' + this.getCorpButtonColor + ' !important',
                        color: this.getCorpButtonColor + ' !important',
                        borderWidth: '1px !important',
                        borderStyle: 'solid !important',
                        borderColor: this.getCorpButtonColor + ' !important'
                    }
                }
            },
            updateHoverState (isHover) {
                this.hoverState = isHover
                console.log('final hover state', this.hoverState)
            },
            styleInterestObject (interestId) {
                let isSelected = this.interestIndexes.filter(x => {
                    return x.toString() === interestId.toString()
                })
                if (isSelected && isSelected.length > 0) {
                    return {
                        color: '#FFFFFF !important',
                        backgroundColor: this.getCorpButtonColor,
                        borderWidth: '1px !important',
                        borderStyle: 'solid !important',
                        borderColor: this.getCorpButtonColor + ' !important'
                        // border: '2px solid' + this.getCorpButtonColor + ' !important'
                    }
                } else {
                    return {
                        // border: '2px solid' + this.getCorpButtonColor + ' !important',
                        color: this.getCorpButtonColor + ' !important',
                        borderWidth: '1px !important',
                        borderStyle: 'solid !important',
                        borderColor: this.getCorpButtonColor + ' !important'
                    }
                }
            },
            shareCorporateVideo () {
                let self = this
                self.shareVideoPayload.corporationId = self.shareOption === 'Corporate' ? 1 : 0
                self.shareVideoPayload.senderUserId = self.user.userId
                self.shareVideoPayload.recipientsUserIds = []
                self.shareVideoPayload.recipientFriendEmails = []
                self.shareVideoPayload.messageText = self.corporateShareMessage
                if (self.shareOption === 'Corporate') {
                    self.shareVideoPayload.recipientsUserIds = []
                    self.shareVideoPayload.recipientFriendEmails = null
                } else if (self.shareOption === 'Individual') {
                    self.shareVideoPayload.recipientFriendEmails = null
                    if (self.selectedCorps && self.selectedCorps.length > 0) {
                        let userIdArray = self.selectedCorps.map(x => {
                            return x.userId
                        })
                        self.shareVideoPayload.recipientsUserIds = userIdArray
                    }
                } else if (self.shareOption === 'Friends') {
                    self.shareVideoPayload.recipientsUserIds = []
                    let emailArray = self.taggedEmails.map(x => {
                        return x.name
                    })
                    self.shareVideoPayload.recipientFriendEmails = emailArray.join(',')
                } else {
                }
                self.shareVideoPayload.playlistId = self.selectedPlaylist.playlistId
                if (self.sharePlaylistType === 'personal') {
                    self.shareVideoPayload.playlistType = 1
                } else if (self.sharePlaylistType === 'corporate') {
                    self.shareVideoPayload.playlistType = 3
                } else if (self.sharePlaylistType === 'trending') {
                    self.shareVideoPayload.playlistType = 2
                }
                // self.shareInProcess = true commented on 09/01/2021

                // Send the Email
                if (!self.shareInProcess) {
                    self.$store.dispatch('PLAYLISTCORPORATESHARE', {payload: self.shareVideoPayload}).then(() => {
                        if (!self.error.show) {
                            self.spinnerToggle()
                            self.$swal({
                                title: 'Playlist has been shared!',
                                text: '',
                                type: 'success',
                                timer: 3000,
                                showCancelButton: false,
                                showConfirmButton: false
                            }).then(
                                function () {
                                },
                                // handling the promise rejection
                                function (dismiss) {
                                    if (dismiss === 'timer') {
                                    }
                                }
                            )
                            // self.spinnerToggle()
                            // self.shareInProcess = false
                            self.cancelCorporateModal()
                        } else {
                            // self.spinnerToggle()
                            // self.shareInProcess = false
                            self.cancelCorporateModal()
                        }
                    })
                }
                self.shareInProcess = true
            },
            showSharingModal (playlist, type) {
                let self = this
                if (self.user && self.user.corporation === null) {
                    self.openModalShare(playlist.playlistId, playlist.title)
                } else {
                    self.openCorporateShareModal(playlist, type)
                }
            },
            verifyEmailShare (email) {
                if (email.length > 0) {
                    let re = /\S+@\S+\.\S+/
                    if (!re.test(email)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            addTag (newTag) {
                let self = this
                console.log('newTAg', newTag)
                const tag = {
                    name: newTag
                }
                if (self.verifyEmailShare(newTag)) {
                    self.emailList.push(tag)
                    this.taggedEmails.push(tag)
                    console.log('tagged emails', this.taggedEmails)
                } else {
                    console.log('invalid email address, calling swal')
                    // self.$swal({
                    //     title: 'Invalid Email Address',
                    //     text: 'Please enter valid email address',
                    //     type: 'error',
                    //     timer: 2000,
                    //     showCancelButton: false,
                    //     showConfirmButton: false
                    // }).then(
                    //     function () {
                    //     },
                    //     // handling the promise rejection
                    //     function (dismiss) {
                    //         if (dismiss === 'timer') {
                    //         }
                    //     }
                    // )
                }
            },
            getDateReference (dte, type) {
                let dt = new Date(dte)
                let dayStr, monStr
                let eDay = dt.getDate()
                let eHours = this.getHoursFormatted(dt)
                let eMonth = dt.getMonth() + 1
                let day
                // Set Day of Date
                if (dt.getDay() === 0) {
                    day = 'Sunday'
                } else if (dt.getDay() === 1) {
                    day = 'Monday'
                } else if (dt.getDay() === 2) {
                    day = 'Tuesday'
                } else if (dt.getDay() === 3) {
                    day = 'Wednesday'
                } else if (dt.getDay() === 4) {
                    day = 'Thursday'
                } else if (dt.getDay() === 5) {
                    day = 'Friday'
                } else if (dt.getDay() === 6) {
                    day = 'Saturday'
                } else {
                    day = ''
                }
                // Set Date Pattern
                if (eDay === 1) {
                    dayStr = '1st'
                } else if (eDay === 2) {
                    dayStr = '2nd'
                } else if (eDay === 3) {
                    dayStr = '3rd'
                } else if (eDay === 21) {
                    dayStr = '21st'
                } else if (eDay === 22) {
                    dayStr = '22nd'
                } else if (eDay === 23) {
                    dayStr = '23rd'
                } else if (eDay === 31) {
                    dayStr = '31st'
                } else {
                    dayStr = eDay + 'th'
                }
                // Set Month
                if (eMonth === 1) {
                    monStr = 'January'
                } else if (eMonth === 2) {
                    monStr = 'February'
                } else if (eMonth === 3) {
                    monStr = 'March'
                } else if (eMonth === 4) {
                    monStr = 'April'
                } else if (eMonth === 5) {
                    monStr = 'May'
                } else if (eMonth === 6) {
                    monStr = 'June'
                } else if (eMonth === 7) {
                    monStr = 'July'
                } else if (eMonth === 8) {
                    monStr = 'August'
                } else if (eMonth === 9) {
                    monStr = 'September'
                } else if (eMonth === 10) {
                    monStr = 'October'
                } else if (eMonth === 11) {
                    monStr = 'November'
                } else if (eMonth === 12) {
                    monStr = 'December'
                }
                if (type === 'btn') {
                    return 'Reserve your spot starting ' + monStr + ' ' + dayStr + '!'
                } else if (type === 'live') {
                    return monStr + ' ' + eDay
                } else if (type === 'live2') {
                    return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET'
                } else if (type === 'str') {
                    return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET'
                } else {
                    return day + ', ' + monStr + ' ' + dayStr + ' @' + eHours + ' ET'
                }
            },
            getHoursFormatted (time) {
                let hours = time.getHours()
                let minutes = time.getMinutes()
                let ampm = hours >= 12 ? 'pm' : 'am'
                hours = hours % 12
                hours = hours === 0 ? '12' : hours
                minutes = minutes < 10 ? '0' + minutes : minutes
                let strTime = hours + ':' + minutes + ' ' + ampm
                return strTime
            },
            playWatchedVideo (videoCode, videoTitle) {
                this.$router.push(`/watch/${videoCode}/${videoTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`)
            },
            returnProgressStyle (progress) {
                return `width: ${progress}%;`
            },
            showPrivateVideoShareMsg () {
                this.$swal({
                    title: 'Cannot Share',
                    text: 'This playlist contains videos which are private and cannot be shared',
                    type: 'info',
                    timer: 3000,
                    showCancelButton: false,
                    showConfirmButton: false
                }).then(
                    function () {
                    },
                    // handling the promise rejection
                    function (dismiss) {
                        if (dismiss === 'timer') {
                        }
                    }
                )
            },
            showDOBFlag () {
                if (this.user) {
                    if (this.user && this.user.corporation) {
                        if (this.user.corporation.dobFlag === 1) {
                            return true
                        } else {
                            return false
                        }
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            showMobFlag () {
                if (this.user) {
                    if (this.user && this.user.corporation) {
                        if (this.user.corporation.phoneFlag === 1 || this.user.corporation.phoneFlag === 2) {
                            return true
                        } else {
                            return false
                        }
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            setDynamicSection (coll, key) {
                let valCol = coll.filter(x => {
                    return x.content_id === key
                })
                if (valCol && valCol.length > 0) {
                    return valCol[0].content_value
                } else {
                    return ''
                }
            },
            openModalShare (playlistId, playlistTitle) {
                let self = this
                if (self.getTrialDays < 0) {
                    self.$router.push(`/becomemember`)
                } else {
                    self.sharePayload.sharedPlaylistId = playlistId
                    self.sharePayload.sharedPlaylistTitle = playlistTitle
                    self.sharePayload.sharedPlaylistPreview = `${self.previewMsg}${self.user.firstName} ${self.user.lastName} shared a playlist with you on TONE Networks: \n${self.sharePayload.sharedPlaylistTitle} \n`
                    self.showSharedModal = true
                }
            },
            verifyEmailList (emailList) {
                let removeWhiteSpace = emailList.filter(x => {
                    return x.trim()
                })
                let updatedList = removeWhiteSpace.filter(x => {
                    return x !== '' && x !== ' ' && x !== '  '
                })
                let self = this
                let re = /\S+@\S+\.\S+/
                for (let i = 0; i < updatedList.length; i++) {
                    if (updatedList[i] && updatedList[i] !== ' ' && !re.test(updatedList[i])) {
                        self.failedEmail = updatedList[i]
                        return false
                    }
                }
                self.failedEmail = ''
                self.sharePayload.sharedEmailList = updatedList.join(',')
                return true
            },
            returnPermissionBasedOnType (type) {
                let self = this
                let rights = 0
                if (type === 'personal') {
                    if (self.user && self.user.corporation && self.user.corporation.corpSharingPermissions && self.user.corporation.corpSharingPermissions.sharePersonalPlaylistPermission >= 1) {
                        rights = self.user.corporation.corpSharingPermissions.sharePersonalPlaylistPermission
                    }
                } else if (type === 'corporate') {
                    if (self.user && self.user.corporation && self.user.corporation.corpSharingPermissions && self.user.corporation.corpSharingPermissions.corpPlaylistShareOptnPermission >= 1) {
                        rights = self.user.corporation.corpSharingPermissions.corpPlaylistShareOptnPermission
                    }
                } else if (type === 'trending') {
                    if (self.user && self.user.corporation && self.user.corporation.corpSharingPermissions && self.user.corporation.corpSharingPermissions.shareTrendingPlaylistPermission >= 1) {
                        rights = self.user.corporation.corpSharingPermissions.shareTrendingPlaylistPermission
                    }
                }
                return rights
            },
            openCorporateShareModal (playlistObj, type) {
                let self = this
                self.sharePlaylistType = type
                self.corpShareModalImage = playlistObj.userPlaylistVideos[0].thumbnailURL
                self.corpShareModalDesc = playlistObj.description
                self.corpShareModalTitle = playlistObj.title
                self.selectedPlaylist = playlistObj
                self.showCorporateShare = true
                let rights = self.returnPermissionBasedOnType(type)
                if (rights === 1) {
                    self.showShareCommunity = true
                    self.showShareIndividual = true
                    self.showShareFriends = true
                } else if (rights === 2) {
                    self.showShareCommunity = true
                    self.showShareIndividual = false
                    self.showShareFriends = false
                    self.shareOption = 'Corporate'
                } else if (rights === 3) {
                    self.showShareCommunity = false
                    self.showShareFriends = false
                    self.showShareIndividual = true
                    self.shareOption = 'Individual'
                } else if (rights === 5) {
                    self.showShareCommunity = false
                    self.showShareIndividual = false
                    self.showShareFriends = true
                    self.shareOption = 'Friends'
                } else {
                    self.showShareCommunity = false
                    self.showShareIndividual = false
                    self.showShareFriends = false
                }
            },
            // shareCorporateVideo () {
            //     let self = this
            //     self.shareVideoPayload.corporationId = self.shareOption === 'Corporate' ? 1 : 0
            //     self.shareVideoPayload.senderUserId = self.user.userId
            //     self.shareVideoPayload.recipientsUserIds = []
            //     self.shareVideoPayload.messageText = self.corporateShareMessage
            //     if (self.shareVideoPayload.corporationId !== 1) { // Being sent to individuals
            //         if (self.selectedCorps && self.selectedCorps.length > 0) {
            //             self.shareVideoPayload.recipientsUserIds = self.selectedCorps.map(x => {
            //                 return x.userId
            //             })
            //         }
            //     }
            //     self.shareVideoPayload.playlistId = self.selectedPlaylist.playlistId
            //     // Send the Email
            //     self.$store.dispatch('PLAYLISTCORPORATESHARE', {payload: self.shareVideoPayload}).then(() => {
            //         if (!self.error.show) {
            //             self.spinnerToggle()
            //             self.$swal({
            //                 title: 'Playlist has been shared!',
            //                 text: '',
            //                 type: 'success',
            //                 timer: 3000,
            //                 showCancelButton: false,
            //                 showConfirmButton: false
            //             }).then(
            //                 function () {
            //                 },
            //                 // handling the promise rejection
            //                 function (dismiss) {
            //                     if (dismiss === 'timer') {
            //                     }
            //                 }
            //             )
            //             self.spinnerToggle()
            //             self.cancelCorporateModal()
            //         } else {
            //             self.spinnerToggle()
            //             self.cancelCorporateModal()
            //         }
            //     })
            // },
            maskEmailAddress (userEmail) {
                let avg, splitted, part1, part2
                splitted = userEmail.split('@')
                part1 = splitted[0]
                let regex = /[^0-9.]/g
                let maskid = part1.substring(0, 1) + part1.replace(regex, '*').substring(1)
                console.log('maked', maskid)
                avg = part1.length / 2
                part1 = part1.substring(0, (part1.length - avg))
                part2 = splitted[1]
                let maskDomain = part2.split('.')
                return maskid + '@' + maskDomain[0].replace(regex, '*') + '.' + maskDomain[maskDomain.length - 1]
            },
            customLabel (option) {
                let findDuplicate = this.allCorps.find(x => {
                    return x.firstName.toLowerCase() === option.firstName.toLowerCase() && x.lastName.toLowerCase() === option.lastName.toLowerCase() && x.userId !== option.userId
                })
//            console.log('findDuplicate', findDuplicate)
                if (findDuplicate) {
                    let maskedEmail = this.maskEmailAddress(option.email)
                    return `${option.firstName} ${option.lastName} <${maskedEmail}>`
                } else {
                    return `${option.firstName} ${option.lastName}`
                }
            },
            cancelCorporateModal () {
                $('html').removeClass('model-open')
                var self = this
                window.setTimeout(function () {
                    self.showCorporateShare = false
                    self.shareInProcess = false
                    self.sharePlaylistType = ''
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            },
            onSharePlaylist () {
                let self = this
                self.spinnerToggle()
                let emailArray = self.taggedEmails.map(x => {
                    return x.name
                })
                self.sharePayload.sharedPlaylistPreview = `${self.user.firstName} ${self.user.lastName} shared a playlist with you on TONE Networks: \n${self.sharePayload.sharedPlaylistTitle}\n${self.sharePayload.sharedEmailMessage}`
                let sharePayload = {
                    csvEmailRecepients: emailArray.join(','),
                    userId: self.user.userId,
                    playlistId: self.sharePayload.sharedPlaylistId,
                    customizedMessage: self.sharePayload.sharedPlaylistPreview
                }
                self.$store.dispatch('EMAILSHAREPLAYLIST', {payload: sharePayload}).then(() => {
                    if (!self.error.show) {
                        self.spinnerToggle()
                        self.$store.dispatch('GET_TAGGED_EMAIL_LIST', self.user.userId).then(() => {
                            if (self.getTaggedEmailList) {
                                self.emailList = []
                                self.emailList = self.getTaggedEmailList
                                self.taggedEmails = []
                                self.sharePayload.sharedPlaylistPreview = ''
                            }
                        })
                        self.$swal({
                            title: 'Email Sent!',
                            text: '',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                        self.cancelModal()
                    } else {
                        self.spinnerToggle()
                        self.cancelModal()
                    }
                })
            },
            cancelModal () {
                var self = this
                var $ = window.jQuery
                self.sharePayload.sharedPlaylistId = 0
                self.sharePayload.sharedPlaylistTitle = ''
                self.sharePayload.sharedEmailList = ''
                self.sharePayload.sharedEmailMessage = ''
                self.sharePayload.sharedPlaylistPreview = `${self.user.firstName} ${self.user.lastName} shared a playlist with you on TONE Networks: \n${self.sharePayload.sharedPlaylistTitle} \n`
                setTimeout(function () {
                    self.showSharedModal = false
                    /* remove the class added by default by modal, when open to retain the scrolling behaviour */
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            },
            playProgressPlaylist (playlistId, playlistType, playlistTitle = '', videoCode, videoTitle = '') {
                if (this.getTrialDays < 0) {
                    this.$router.push(`/becomemember`)
                } else {
                    if (playlistType.toString().toLowerCase() === 'corporation') {
                        this.$router.push(`/playlist/${playlistId}/play/${videoCode}/${this.user.corporation.corporationId}/${playlistTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`)
                    } else if (playlistType.toString().toLowerCase() === 'trending') {
                        this.$router.push(`/playlist/trending/${playlistId}/play/${videoCode}/${videoTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`)
                    } else {
                        this.$router.push(`/playlist/${playlistId}/play/${videoCode}`)
                    }
                }
            },
            playPlaylist (playlistId, videoCode) {
                if (this.getTrialDays < 0) {
                    this.$router.push(`/becomemember`)
                } else {
                    this.$router.push(`/playlist/${playlistId}/play/${videoCode}`)
                }
            },
            playTrendingPlaylist (playlistId, videoCode, videoTitle) {
                if (this.getTrialDays < 0) {
                    this.$router.push(`/becomemember`)
                } else {
                    this.$router.push(`/playlist/trending/${playlistId}/play/${videoCode}/${videoTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`)
                }
            },
            playCorpPlaylist (playlistId, videoCode, playlistTitle) {
                if (this.getTrialDays < 0) {
                    this.$router.push(`/becomemember`)
                } else {
                    this.$router.push(`/playlist/${playlistId}/play/${videoCode}/${this.user.corporation.corporationId}/${playlistTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`)
                }
            },
            removePlaylist (playlistId) {
                let self = this
                if (self.getTrialDays < 0) {
                    self.$router.push(`/becomemember`)
                } else {
                    let removePayload = {
                        userId: self.user.userId,
                        playlistId: playlistId
                    }
                    self.$swal({
                        title: 'Remove',
                        text: 'Are you sure you want to remove this playlist?',
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Yes, Please',
                        cancelButtonText: 'Cancel',
                        confirmButtonClass: 'btn btn-success',
                        cancelButtonClass: 'btn btn-danger',
                        buttonsStyling: false
                    }).then(function (result) {
                        self.$store.dispatch('REMOVEPLAYLIST', {playlist: removePayload}).then(() => {
                            self.$swal({
                                title: 'Playlist has been removed',
                                text: '',
                                type: 'success',
                                timer: 3000,
                                showCancelButton: false,
                                showConfirmButton: false
                            }).then(
                                function () {
                                },
                                // handling the promise rejection
                                function (dismiss) {
                                    if (dismiss === 'timer') {
                                    }
                                }
                            )
                            console.log('called after removing')
                            self.$store.dispatch('GET_USER_PLAYLISTS_PROFILE', self.user.userId).then(() => {
                                if (self.getUserPlaylistsProfile) {
                                    self.userPersonalPlaylists = null
                                    self.userPersonalPlaylists = self.getUserPlaylistsProfile.userPlaylists ? self.getUserPlaylistsProfile.userPlaylists : null
                                }
                            })
                        })
                    }, function (dismiss) {
                    })
                }
//                this.$store.dispatch('REMOVEPLAYLIST', {playlist: removePayload}).then(() => {
//                })
            },
            setPlaylistVideoStatus (video, playlist, currentStatus) {
                let self = this
                self.selectedVideo = video.mediaid
                self.selectedPlaylist = playlist.playlistId
                if (currentStatus) { // Video is unSelected
                    let payload = {}
                    payload.videoCode = video.mediaid
                    payload.userPlaylistId = playlist.playlistId
                    payload.userId = this.user.userId
                    this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', {playlist: payload}).then(() => {
                        self.videoAdded = false
                        self.videoRemoved = true
                    })
                } else { // Video is Selected
                    let payload = {}
                    payload.videoCode = video.mediaid
                    payload.userId = this.user.userId
                    payload.userPlaylistId = playlist.playlistId
                    this.$store.dispatch('ADDVIDEOINPLAYLIST', {playlist: payload}).then(() => {
                        // this.charities = this.getAuthUserVideos
                        self.videoAdded = true
                        self.videoRemoved = false
                    })
                }
                setTimeout(() => {
                    self.videoAdded = false
                    self.videoRemoved = false
                }, 1500)
            },
            verifyPlaylistExists () {
                if (this.getUserPlaylists) {
                    let playlistsWithVideo = this.getUserPlaylists.filter(x => {
                        return x.userPlaylistVideos !== null
                    })
                    if (playlistsWithVideo && playlistsWithVideo.length > 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            verifyVideoExists (playlist, video) {
                let self = this
                if (this.getUserPlaylists) {
                    let findPlaylist = this.getUserPlaylists.filter(x => {
                        return x.playlistId === playlist.playlistId
                    })
                    if (findPlaylist && findPlaylist.length > 0) {
                        if (findPlaylist[0].userPlaylistVideos !== null && findPlaylist[0].userPlaylistVideos.length > 0) {
                            let videos = findPlaylist[0].userPlaylistVideos.filter(x => {
                                return x.videoCode === video.mediaid
                            })
                            if (videos && videos.length > 0) {
                                self.playlistHasVideo = true
                                return true
                            } else {
                                return false
                            }
                        } else {
                            return false
                        }
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            addNewPlayList () {
                if (this.newPlaylistName && this.newPlaylistName.length > 0) {
                    let payload = {}
                    payload.userId = this.user.userId
                    payload.title = this.newPlaylistName
                    this.$store.dispatch('CREATEPLAYLIST', {playlist: payload}).then(() => {
                        this.newPlaylistName = ''
                        // this.charities = this.getAuthUserVideos
                    })
                }
            },
            showPlaylistMenu (videoCode) {
               // console.log(videoCode)
                $('#' + videoCode + ' + ul').toggleClass('hide')
            },
//            showHideCoolCard (divRef) {
//                $('.container.boxescontiner .row.nospace.flexrow > div').on('click', function () {
//                    $(this).toggleClass('active')
//                })
//            },
            hidePlaylistMenu (videoCode) {
               // console.log(videoCode)
                $('#' + videoCode + ' + ul').toggleClass('hide')
            },
            mountbraintree () {
                let self = this
                if (self.getPaypalToken) {
                    window.braintree.client.create({
                        authorization: 'production_6r7mxqgh_htw3nq9wp32w8h2x'
                    }, function (clientErr, clientInstance) {
                        // Stop if there was a problem creating the client.
                        // This could happen if there is a network error or if the authorization
                        // is invalid.
                        if (clientErr) {
                            console.error('Error creating client:', clientErr)
                            return
                        }
                        // Create a PayPal Checkout component.
                        window.braintree.paypalCheckout.create({
                            client: clientInstance
                        }, function (paypalCheckoutErr, paypalCheckoutInstance) {
                            // Stop if there was a problem creating PayPal Checkout.
                            // This could happen if there was a network error or if it's incorrectly
                            // configured.
                            if (paypalCheckoutErr) {
                                console.error('Error creating PayPal Checkout:', paypalCheckoutErr)
                                return
                            }
                            // Set up PayPal with the checkout.js library
                            window.paypal.Button.render({
                                env: 'production', // or 'sandbox'
                                payment: function () {
                                    return paypalCheckoutInstance.createPayment({
                                        flow: 'vault',
                                        amount: 5,
                                        currency: 'USD',
                                        intent: 'sale'
                                        // Your PayPal options here. For available options, see
                                        // http://braintree.github.io/braintree-web/current/PayPalCheckout.html#createPayment
                                    })
                                },
                                onAuthorize: function (data, actions) {
                                    return paypalCheckoutInstance.tokenizePayment(data)
                                        .then(function (payload) {
                                            // console.log('nonce', payload.nonce)
                                            // Submit `payload.nonce` to your server.
                                            self.userPayments.paymentMethodNonce = payload.nonce
                                            self.userPayments.paymentType = 'PayPal'
                                        })
                                },
                                onCancel: function (data) {
                                    // console.log('checkout.js payment cancelled', JSON.stringify(data, 0, 2))
                                },
                                onError: function (err) {
                                    console.error('checkout.js error', err)
                                }
                            }, '#paypal-button').then(function () {
                                // The PayPal button will be rendered in an html element with the id
                                // `paypal-button`. This function will be called when the PayPal button
                                // is set up and ready to be used.
                            })
                        })
                    })
                }
            },
            getRelatedImage (image) {
                if (this.getDefaultImages) {
                    let defImage = this.getDefaultImages.filter(img => {
                        return img.smallImgUrl === image
                    })
                    return defImage[0].url
                }
            },
            updateCharity () {
                this.isCharityUpdate = false
                sessionStorage.setItem('updatRedirect', true)
                this.$router.push('/giving')
            },
            checkAllInterests () {
                // Update Interest Index for selection
                this.interestIndexes = []
                for (var i = 0, l = this.getAllInterests.length; i < l; i++) {
                    this.interestIndexes.push(i)
                }
            },
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            showUpdateName () {
                this.showUpdateNameBox = !this.showUpdateNameBox
            },
            showUpdateMobile () {
                this.showUpdateMobileBox = !this.showUpdateMobileBox
            },
            showUpdateDOB () {
                this.showUpdateDOBBox = !this.showUpdateDOBBox
            },
            showUpdatePassword () {
                this.showUpdatePasswordBox = !this.showUpdatePasswordBox
            },
            showUpdateEmail () {
                this.showUpdateEmailBox = !this.showUpdateEmailBox
            },
            showUpdatePayment () {
                this.showPaymentBox = !this.showPaymentBox
                if (this.showPaymentBox) {
                    if (this.user.stripeCustomerId) {
                        this.mountStripeElements()
                    } else {
                        this.mountbraintree()
                    }
                    this.showPaymentHistoryBox = false
                }
            },
            showPaymentHistory () {
                if (!this.showPaymentHistoryBox) {
                    window.logEvents('Profile Page', 'click', 'Payment History Viewed')
                }
                this.showPaymentHistoryBox = !this.showPaymentHistoryBox
            },
            switchTab: function (id) {
                console.log('id', id)
                for (let tab in this.tabs) {
                    this.tabs[tab] = id === tab
                }
                if (id === 'discussion') {
                    this.$store.dispatch('DEFAULTIMAGESLIST').then(() => {
                        if (this.getDefaultImages) {
                            setTimeout(() => {
                                this.setCarousal()
                            }, 2000)
                        }
                    })
                }
            },
            getInterestStatus (interest) {
                if (this.getUserInterests) {
                    let exists = this.getUserInterests.filter(selectedInterestId => {
                        return selectedInterestId.interestId === interest.interestId
                    })
                    if (exists && exists.length > 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            setVideoPlayerObject (videoCode) {
                if (this.getTrialDays < 0) {
                    this.$router.push(`/becomemember`)
                } else {
                    this.$router.push(`/watch/${videoCode}`)
                }
            },
            verifyPassword () {
                if (this.updatedPassword.length >= 6) {
                    let re = /^(?=.*?[A-Z])(?=.*?[a-z]).{6,}$/
                    if (!re.test(this.updatedPassword)) {
                        this.passwordError = 'Min 6 Chars, One Upper Case, One Lower Case!'
                        return false
                    }
                    if (this.confirmPassword.length > 0) {
                        if (this.updatedPassword === this.confirmPassword) {
                            return true
                        } else {
                            this.passwordError = 'Password do not match'
                            return false
                        }
                    } else {
                        return true
                    }
                } else {
                    if (this.updatedPassword.length > 0) {
                        this.passwordError = 'Min 6 Chars, One Upper Case, One Lower Case!'
                        return false
                    } else {
                        return true
                    }
                }
            },
            verifyEmail (emailField) {
                if (emailField.length > 0) {
                    let re = /\S+@\S+\.\S+/
                    if (!re.test(emailField)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            setCarousal () {
                $.slick = slick
                const $slick = $(this.$el).find('.responsive-slick-imagelist')
                $slick.each(function () {
                    $slick.slick({
                        dots: false,
                        infinite: false,
                        speed: 300,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        responsive: [{
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                infinite: true,
                                dots: false
                            }
                        }, {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }, {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }]
                    })
                })
            },
            updateInterests () {
                // console.log('this.selectedDays.length = ', this.selectedDays.length)
                if (this.selectedDays.length > 1) {
                    this.spinnerToggle()
                    const days = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY']
                    const daysSelected = []
                    this.selectedDays.forEach(index => {
                        daysSelected.push(days[index])
                    })
                    const setDaysData = { userId: this.user.userId, days: daysSelected }
                    for (var i = 0, l = this.interestIndexes.length; i < l; i++) {
                        let newUserInterest = {}
                        let selectedInterest = this.getAllInterests[this.interestIndexes[i]]
                        // newUserInterest.userId = this.user.userId
                        newUserInterest.interestId = selectedInterest.interestId
                        newUserInterest.count = 5
                        this.userInterests.push(newUserInterest)
                    }
                    this.user.interests = this.userInterests
                    this.$store.dispatch('SETDAYS', {data: setDaysData}).then(() => {
                    })
                    this.$store.dispatch('UPDATEINTERESTS', {loggedUser: this.user}).then(() => {
                        this.spinnerToggle()
                        this.$swal({
                            title: 'Your changes have been saved',
                            text: '',
                            type: 'success',
                            timer: 2000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                    })
                } else {
                    this.$swal({
                        title: 'Please select at least two delivery days',
                        text: '',
                        type: 'error',
                        timer: 2000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(
                        function () {
                        },
                        // handling the promise rejection
                        function (dismiss) {
                            if (dismiss === 'timer') {
                            }
                        }
                    )
                }
            },
            onNameSubmit () {
                this.spinnerToggle()
                this.user.firstName = this.updatedFirstName
                this.user.lastName = this.updatedLastName
                this.$store.dispatch('UPDATEUSERPROFILE', this.user).then(() => {
                   // this.log('updated profile', this.user)
                    this.spinnerToggle()
                    this.showUpdateName()
                })
            },
            onMobileSubscriptionChanged () {
                this.spinnerToggle()
                if (this.isMobileSubscribe) {
                    this.user.isOptOutSMS = '1'
                } else {
                    this.user.isOptOutSMS = '0'
                }
                this.$store.dispatch('UPDATEUSERPROFILE', this.user).then(() => {
                    // this.log('updated profile', this.user)
                    this.spinnerToggle()
                })
            },
            onMobileNotificationChanged () {
                this.spinnerToggle()
                if (this.isPushNotificationSubscribe) {
                    this.user.isOptOutPn = '1'
                } else {
                    this.user.isOptOutPn = '0'
                }
                this.$store.dispatch('UPDATEUSERPROFILE', this.user).then(() => {
                    // this.log('updated profile', this.user)
                    this.spinnerToggle()
                })
            },
            onMobileSubmit () {
                this.spinnerToggle()
                if (this.rawPhoneNumber.toString().indexOf('_') === -1) {
                    this.user.phoneNumber = this.phoneNumber
                    this.$store.dispatch('UPDATEUSERPROFILE', this.user).then(() => {
                        // this.log('updated profile', this.user)
                        this.spinnerToggle()
                        this.showUpdateMobile()
                    })
                }
            },
            setDefaultImage (defaultImage) {
                window.logEvents('Profile Page', 'click', `Default picture changed to: ${defaultImage.title}`)
                this.spinnerToggle()
                this.user.picture = defaultImage.smallImgUrl
                this.$store.dispatch('UPDATEUSERPROFILE', this.user).then(() => {
                    // this.log('updated profile', this.user)
                })
            },
            onDOBSubmit () {
                this.spinnerToggle()
                this.user.dob = this.updatedDOB
                this.$store.dispatch('UPDATEUSERPROFILE', this.user).then(() => {
                    this.spinnerToggle()
                    this.showUpdateDOB()
                })
                // this.$router.push('/interestlist')
            },
            onNewCardSubmit () {
                var self = this
                this.spinnerToggle()
                if (this.isStripe) {
                    this.stripe.createToken(this.card).then((result) => {
                        if (result.error) {
                            var errorElement = document.getElementById('card-errors')
                            errorElement.textContent = result.error.message
                            this.spinnerToggle()
                        } else {
                            // Send the token to your server
                            const stripeToken = result.token.id
                            this.userPayments.stripeCardId = result.token.card.id
                            // if (paymentStatus !== 'undefined' || paymentStatus !== 'null') {
                            //    this.user.userPayments[0].token = stripeToken
                            // } else {
                            this.userPayments.token = stripeToken
                            this.user.userPayments = []
                            this.user.userPayments.push(this.userPayments)
                            this.$store.dispatch('UPDATECREDITCARD', this.user).then(() => {
                                if (!this.error.show) {
                                    this.spinnerToggle()
                                    self.showUpdatePayment()
                                    self.$store.dispatch('GETCREDITCARDINFO', this.user.userId).then(() => {
                                        this.$swal({
                                            title: 'Payment Method Changed!',
                                            text: '',
                                            type: 'success',
                                            timer: 3000,
                                            showCancelButton: false,
                                            showConfirmButton: false
                                        }).then(
                                            function () {
                                            },
                                            // handling the promise rejection
                                            function (dismiss) {
                                                if (dismiss === 'timer') {
                                                }
                                            }
                                        )
                                    })
                                } else {
                                    this.spinnerToggle()
                                }
                            })
                        }
                    })
                } else {
                    if (this.userPayments.paymentMethodNonce) {
                        // this.userPaymentsCol.push(this.userPayments)
                        this.user.userPayments = []
                        this.user.userPayments.push(this.userPayments)
                        // this.user.userPayments = this.userPaymentsCol
                        // this.userPaymentsCol.pop()
                        this.$store.dispatch('UPDATECREDITCARD', this.user).then(() => {
                            if (!this.error.show) {
                                this.spinnerToggle()
                                self.showUpdatePayment()
                                this.$swal({
                                    title: 'Payment Method Changed!',
                                    text: '',
                                    type: 'success',
                                    timer: 3000,
                                    showCancelButton: false,
                                    showConfirmButton: false
                                }).then(
                                    function () {
                                    },
                                    // handling the promise rejection
                                    function (dismiss) {
                                        if (dismiss === 'timer') {
                                        }
                                    }
                                )
                            } else {
                                this.spinnerToggle()
                            }
                        })
                    } else {
                        this.$swal({
                            title: 'Please first click above paypal button to authorize',
                            type: 'error',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                        this.spinnerToggle()
                    }
                }
            },
            onPasswordSubmit () {
                // var self = this
                if (this.verifyPassword()) {
                    this.spinnerToggle()
                    let passwords = {}
                    passwords.email = this.user.email.toLowerCase()
                    passwords.password = this.oldPassword
                    passwords.newPassword = this.updatedPassword
                    this.$store.dispatch('UPDATEPROFILEPASSWORD', {passwords: passwords}).then(() => {
                        this.spinnerToggle()
                        this.showUpdatePassword()
//                        this.$swal({
//                            title: 'Registration Success!',
//                            text: '',
//                            type: 'success',
//                            timer: 4000,
//                            showCancelButton: false,
//                            showConfirmButton: false
//                        }).then(
//                            function () {
//                            },
//                            // handling the promise rejection
//                            function (dismiss) {
//                                if (dismiss === 'timer') {
//                                }
//                            }
//                        )
                    })
                }
                // this.$router.push('/interestlist')
            },
            onEmailChangeSubmit () {
                var self = this
                if (this.verifyEmail(this.newEmail)) {
                    this.spinnerToggle()
                    let payload = {}
                    payload.userId = this.user.userId
                    payload.email = this.newEmail.toLowerCase()
                    payload.oldEmail = this.user.email.toString().toLowerCase()
                    payload.password = this.oldPasswordForEmail
                    this.$store.dispatch('UPDATEPROFILEEMAIL', {payload: payload}).then(() => {
                        if (self.error.show && self.error.originalMessage !== 'aws.cognito.UserNotConfirmed') {
                            self.spinnerToggle()
                            self.$swal({
                                title: self.error.message,
                                text: '',
                                type: 'error',
                                timer: 2000,
                                showCancelButton: false,
                                showConfirmButton: false
                            }).then(
                                function () {
                                },
                                // handling the promise rejection
                                function (dismiss) {
                                    if (dismiss === 'timer') {
                                    }
                                }
                            )
                        } else { // Successful Change
                            self.$swal({
                                title: 'Check your email for confirmation',
                                text: '',
                                type: 'success',
                                timer: 3000,
                                showCancelButton: false,
                                showConfirmButton: false
                            }).then(
                                function () {
                                },
                                // handling the promise rejection
                                function (dismiss) {
                                    if (dismiss === 'timer') {
                                    }
                                }
                            )
                            // Update User Payload
                            let logUser = localStorage.getItem('loggedUser')
                            let logUserTemp = sessionStorage.getItem('loggedUserTemp')
                            if (logUserTemp) {
                                logUserTemp = JSON.parse(sessionStorage.getItem('loggedUserTemp'))
                                logUserTemp.status = 'Registered'
                                logUserTemp.email = payload.email
                                self.user.status = 'Registered'
                                self.user.email = payload.email
                                sessionStorage.setItem('loggedUserTemp', JSON.stringify(logUserTemp))
                            }
                            if (logUser) {
                                logUser = JSON.parse(localStorage.getItem('loggedUser'))
                                logUser.status = 'Registered'
                                logUser.email = payload.email
                                self.user.status = 'Registered'
                                self.user.email = payload.email
                                localStorage.setItem('loggedUser', JSON.stringify(logUser))
                            }
                            this.spinnerToggle()
                            this.showUpdateEmail()
                        }
                    })
                }
                // this.$router.push('/interestlist')
            },
            mountStripeElements () {
                setTimeout(() => {
                    // stripeKey: 'pk_test_SLHUyTkZmNS1OnLNdclgNldo',
                    this.stripe = window.Stripe('pk_test_SLHUyTkZmNS1OnLNdclgNldo')
                    const elements = this.stripe.elements()
                    this.card = elements.create('card')
                    this.card.mount('#card-element')
                }, 500)
            },
            cancelSubscription () {
                let self = this
                let userId = self.user.userId
                self.$swal({
                    title: 'Unsubscribe',
                    text: 'Are you sure you want to unsubscribe?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, Please',
                    cancelButtonText: 'Cancel',
                    confirmButtonClass: 'btn btn-success',
                    cancelButtonClass: 'btn btn-danger',
                    buttonsStyling: false
                }).then(function (result) {
                    store.dispatch('CANCELSUBSCRIPTION', userId).then(() => {
                        self.user.status = 'CANCELLED'
                        self.$swal({
                            title: 'Check your email for confirmation',
                            text: '',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                    })
                }, function (dismiss) {
                })
                // this.$store.dispatch('LOGOUT')
            },
            setVideoStatus (videoObject) {
                if (this.getAuthUserVideos) {
                    let mediaId = videoObject.mediaid
                    let exists = this.getAuthUserVideos.filter(videoObject => {
                        return videoObject.videoCode === mediaId
                    })
                    if (exists && exists.length > 0) {
                        exists[0].liked = '0'
                    }
                    this.$store.dispatch('SETVIDEOSTATUS', exists[0]).then(() => {
                        this.getAuthUserFavVideos.splice(this.getAuthUserFavVideos.indexOf(videoObject), 1)
                    })
                }
            },
            isHidden () {
                console.log('Profile.vue : isHidden () = ', this.user && this.user.corporation && this.user.corporation.corporationId === 200)
                return this.user && this.user.corporation && this.user.corporation.corporationId === 200
            }
        },
        computed: {
            ...mapGetters([
                'getAllInterests', 'getCorporatePayload', 'getSelectedCharity', 'user', 'error', 'getUserInterests', 'getAuthUserFavVideos', 'getBillingHistory', 'getDefaultImages', 'getPaypalToken', 'getCreditCardInfo', 'getAlertMsgStatus', 'getAuthUserVideos', 'getUserPlaylists', 'getUserPlaylistsWithVideos', 'getTrialDays', 'getAllSiteContents', 'getCardExpiryDays', 'getUserPlaylistsProfile', 'getUserProgressProfile', 'getUpcomingEvent', 'getProfileCharitySection', 'getExpert', 'getTaggedEmailList', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor'
            ]),
            styleInterestObjectComp (interestId) {
                let isSelected = this.interestIndexes.filter(x => {
                    x.interestId === interestId
                })
                if (isSelected && isSelected.length > 0) {
                    return {
                        color: '#FFFFFF',
                        backgroundColor: this.getCorpButtonColor,
                        borderColor: this.getCorpButtonColor
                    }
                } else {
                    return {
                        border: '2px solid' + this.getCorpButtonColor + ' !important',
                        color: this.getCorpButtonColor
                    }
                }
            }
        },
        mounted () {
            let self = this
            setTimeout(function () {
                window.addeventatc.refresh()
            }, 2000)
            // console.log('profile charity section', this.getProfileCharitySection)
            let param = this.$route.params.feature
            $('.container.boxescontiner .row.nospace.flexrow > div').on('click', function () {
                let clickedDiv = $(this)[0].id
                let oldDiv = ''
                let activeRef = $('.container.boxescontiner .row.nospace.flexrow').find('.active')
                if (activeRef[0] === undefined) { // Verify if there is an element clicked already
                } else {
                    oldDiv = activeRef[0].id
                }
                $('.container.boxescontiner .row.nospace.flexrow > div').removeClass('active')
                if (clickedDiv !== oldDiv) {
                    $(this).addClass('active')
                }
            })
            if (this.user.isOptOutSMS === '1') {
                this.isMobileSubscribe = true
            } else {
                this.isMobileSubscribe = false
            }
            if (this.user.isOptOutPn === '1') {
                this.isPushNotificationSubscribe = true
            } else {
                this.isPushNotificationSubscribe = false
            }
            if (param && param.toLowerCase() === 'playlist') {
                this.switchTab('playlist')
                self.$store.dispatch('GETDYNAMICCONTENTS', 31).then(() => {
                    if (self.getAllSiteContents) {
                        // Load Meta Tags
                        this.metaTag_pageTitle = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_PAGE_TITLE')
                        this.metaTag_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_DESCRIPTION')
                        this.metaTag_keywords = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_KEYWORDS')
                        // OpenGraph Tags
                        this.metaTag_fb_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE')
                        this.metaTag_fb_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE')
                        this.metaTag_fb_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION')
                        this.metaTag_fb_sitename = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME')
                        // Twitter Tags
                        this.metaTag_tw_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_TITLE')
                        this.metaTag_tw_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE')
                        this.metaTag_tw_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION')
                    }
                })
            } else if (param && param.toLowerCase() === 'myprogress') {
                this.switchTab('coolFeatures')
                self.$store.dispatch('GETDYNAMICCONTENTS', 32).then(() => {
                    if (self.getAllSiteContents) {
                        // Load Meta Tags
                        this.metaTag_pageTitle = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_PAGE_TITLE')
                        this.metaTag_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_DESCRIPTION')
                        this.metaTag_keywords = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_KEYWORDS')
                        // OpenGraph Tags
                        this.metaTag_fb_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE')
                        this.metaTag_fb_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE')
                        this.metaTag_fb_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION')
                        this.metaTag_fb_sitename = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME')
                        // Twitter Tags
                        this.metaTag_tw_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_TITLE')
                        this.metaTag_tw_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE')
                        this.metaTag_tw_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION')
                    }
                })
            } else if (param && param.toLowerCase() === 'personalize') {
                this.switchTab('chat')
                self.$store.dispatch('GETDYNAMICCONTENTS', 33).then(() => {
                    if (self.getAllSiteContents) {
                        // Load Meta Tags
                        this.metaTag_pageTitle = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_PAGE_TITLE')
                        this.metaTag_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_DESCRIPTION')
                        this.metaTag_keywords = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_KEYWORDS')
                        // OpenGraph Tags
                        this.metaTag_fb_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE')
                        this.metaTag_fb_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE')
                        this.metaTag_fb_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION')
                        this.metaTag_fb_sitename = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME')
                        // Twitter Tags
                        this.metaTag_tw_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_TITLE')
                        this.metaTag_tw_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE')
                        this.metaTag_tw_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION')
                    }
                })
            } else if (param && param.toLowerCase() === 'myfav') {
                this.switchTab('videos')
                self.$store.dispatch('GETDYNAMICCONTENTS', 34).then(() => {
                    if (self.getAllSiteContents) {
                        // Load Meta Tags
                        this.metaTag_pageTitle = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_PAGE_TITLE')
                        this.metaTag_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_DESCRIPTION')
                        this.metaTag_keywords = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_KEYWORDS')
                        // OpenGraph Tags
                        this.metaTag_fb_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE')
                        this.metaTag_fb_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE')
                        this.metaTag_fb_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION')
                        this.metaTag_fb_sitename = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME')
                        // Twitter Tags
                        this.metaTag_tw_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_TITLE')
                        this.metaTag_tw_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE')
                        this.metaTag_tw_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION')
                    }
                })
            } else {
                self.$store.dispatch('GETDYNAMICCONTENTS', 15).then(() => {
                    if (self.getAllSiteContents) {
                        // Load Meta Tags
                        this.metaTag_pageTitle = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_PAGE_TITLE')
                        this.metaTag_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_DESCRIPTION')
                        this.metaTag_keywords = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_KEYWORDS')
                        // OpenGraph Tags
                        this.metaTag_fb_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE')
                        this.metaTag_fb_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE')
                        this.metaTag_fb_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION')
                        this.metaTag_fb_sitename = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME')
                        // Twitter Tags
                        this.metaTag_tw_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_TITLE')
                        this.metaTag_tw_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE')
                        this.metaTag_tw_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION')
                    }
                })
                this.$store.dispatch('DEFAULTIMAGESLIST').then(() => {
                    if (this.getDefaultImages) {
                        setTimeout(() => {
                            this.setCarousal()
                        }, 2000)
                    }
                })
            }
            if (this.user.isPaypalCustomer === '1') {
                this.$store.dispatch('GETPAYPALTOKEN')
            } else {
                this.$store.dispatch('GETCREDITCARDINFO', this.user.userId)
            }
            // Get Tagged Email List
            self.$store.dispatch('GET_TAGGED_EMAIL_LIST', self.user.userId).then(() => {
                if (self.getTaggedEmailList) {
                    self.emailList = []
                    self.emailList = self.getTaggedEmailList
                    console.log('email list', self.getTaggedEmailList)
                }
            })
            let corpId = 0
            if (this.user.corporation && this.user.corporation.corporationId > 0) {
                corpId = this.user.corporation.corporationId
            }
            this.$store.dispatch('GETALLINTERESTS', corpId).then(() => {
                this.$store.dispatch('GETUSERINTERESTS', this.user.userId).then(() => {
                    // Update Interest Index for selection
                    for (var i = 0, l = this.getAllInterests.length; i < l; i++) {
                        if (this.getInterestStatus(this.getAllInterests[i])) {
                            this.interestIndexes.push(i)
                        }
                    }
                })
            })
            this.$store.dispatch('GETALLEMAILDAYS', corpId).then((data) => {
                this.$store.dispatch('GETALLEMAILDAYS', this.user.userId).then((data) => {
                    const capitalizedDays = this.daysOfWeek.map(day => day.toUpperCase())
                    for (var i = 0; i < data.length; i++) {
                        let index = capitalizedDays.indexOf(data[i])
                        if (index !== -1) {
                            this.selectedDays.push(index)
                        }
                    }
                })
            })
            this.$store.dispatch('GETUSERFAVORITEVIDEOS', this.user.userId).then(() => {
            })
            this.$store.dispatch('GETBILLINGHISTORY', {userId: this.user.userId}).then(() => {
            })
            this.$store.dispatch('GETSELECTEDCHARITY', this.user.userId).then(() => {
            })
            if (this.user.stripeCustomerId) {
                this.isStripe = true
            } else {
                this.isStripe = false
            }
            // Get User Liked Videos
            this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId).then(() => {
                // this.charities = this.getAuthUserVideos
            })
            this.$store.dispatch('GET_UPCOMING_EVENT').then(() => {
                if (self.getUpcomingEvent) {
                    console.log('upcoming event', self.getUpcomingEvent)
                    self.upcomingProfileEvent = self.getUpcomingEvent
                    if (self.upcomingProfileEvent) {
                        self.$store.dispatch('GETEXPERT', self.upcomingProfileEvent.expertId)
                    }
                }
            })
            // Get Corporatin Payload if user is part of corporation
            this.$store.dispatch('GETCORPPAYLOAD', this.user.userId).then(() => {
                this.allCorps = []
                if (this.getCorporatePayload) {
                    console.log('payload corp', this.getCorporatePayload)
                    this.corporateInfo = this.getCorporatePayload
                    this.allCorps = this.corporateInfo.lstCorporationUsers
                }
            })
            // Check if user hasn't switched to other corporation
            let switchedCorpId = 0
            if (sessionStorage.getItem('switchClientObject')) {
                let switchedCorp = sessionStorage.getItem('switchClientObject')
                switchedCorp = JSON.parse(switchedCorp)
                switchedCorpId = switchedCorp.corporationId
            }
            let corpToSet = switchedCorpId > 0 ? switchedCorpId : corpId
            let qryParam = [this.user.userId, corpToSet]
            this.$store.dispatch('GET_USER_PLAYLISTS_PROFILE', qryParam).then(() => {
                if (this.getUserPlaylistsProfile) {
                    this.userPersonalPlaylists = this.getUserPlaylistsProfile.userPlaylists ? this.getUserPlaylistsProfile.userPlaylists : null
                    this.userCuratedPlaylists = this.getUserPlaylistsProfile.curatedPlaylists ? this.getUserPlaylistsProfile.curatedPlaylists : null
                    this.userCorpSharedPlaylists = this.getUserPlaylistsProfile.corporationPlaylists ? this.getUserPlaylistsProfile.corporationPlaylists : null
                    console.log('user personal playlists', this.userPersonalPlaylists)
                    // console.log('user curated playlists', this.userCuratedPlaylists)
                    if (this.user && (this.user.corporation && this.user.corporation.enableCorporatePage === 1)) {
                    } else {
                        this.userCorpSharedPlaylists = null
                        // console.log('coporation shared playlist', this.userCorpSharedPlaylists)
                    }
                }
            })
            this.$store.dispatch('GET_USER_PROGRESS_PROFILE', this.user.userId).then(() => {
                if (this.getUserProgressProfile) {
                    this.isPlaylistWatched = this.getUserProgressProfile.anyPlaylistSeen
                    this.userProgressPlaylists = this.getUserProgressProfile.lstPlaylistStatsForProfile ? this.getUserProgressProfile.lstPlaylistStatsForProfile : null
                    this.userProgressEventsAttended = this.getUserProgressProfile.arrEventsAttended ? this.getUserProgressProfile.arrEventsAttended : null
                    this.userProgressVideosWatched = this.getUserProgressProfile.arrWatchedVideos ? this.getUserProgressProfile.arrWatchedVideos : null
                    this.userProgressTakeaways = this.getUserProgressProfile.arrVideosTakeaways ? this.getUserProgressProfile.arrVideosTakeaways : null
                    if (this.userProgressVideosWatched && this.userProgressVideosWatched.length > 0) {
                        if (this.userProgressVideosWatched[0].video_type !== 'WATCHED') {
                            this.isSectionWatched = false
                        }
                    }
                    if (!this.userProgressTakeaways || this.userProgressTakeaways.length === 0) {
                        this.userProgressTakeaways = null
                    }
                    // this.userProgressTakeaways = null
                    // console.log('user progress playlists', this.userProgressPlaylists)
                    // console.log('user progress events', this.userProgressEventsAttended)
                    // console.log('user progress videos watched', this.userProgressVideosWatched)
                    console.log('user progress Takeaways', this.userProgressTakeaways)
                }
            })
            // Get Event Details
            // if (this.getEventList) {
            //     var ev = this.getEventList.filter(e => {
            //         return e.eventId === this.getBannerEvent
            //     })
            //     console.log('get banner event', this.getBannerEvent)
            //     if (ev && ev.length > 0) {
            //         this.upcomingProfileEvent = ev[0]
            //     } else {
            //         this.upcomingProfileEvent = null
            //     }
            // }
            // commented for 683
            // this.$store.dispatch('GETUSERPLAYLISTS', this.user.userId).then(() => {
            //     // this.charities = this.getAuthUserVideos
            // })
            if (this.getAlertMsgStatus) {
                if (this.getTrialDays > 1) {
                    this.expiredTrialMessage = `Your trial period will expire in ${this.getTrialDays} days. Become a Member`
                } else if (this.getTrialDays === 1) {
                    this.expiredTrialMessage = `Your trial is expiring tomorrow. Become a Member`
                } else if (this.getTrialDays === 0) {
                    this.expiredTrialMessage = `Your trial is expiring today. Become a Member`
                } else if (this.getTrialDays < 0) {
                    this.expiredTrialMessage = `Your trial has expired. Become a Member`
                }
            }
            this.$store.dispatch('GETDYNAMICCONTENTS', 15).then(() => {
                let self = this
                if (self.getAllSiteContents) {
                    self.imageText = this.setDynamicSection(this.getAllSiteContents, 'PROFILE_IMAGE_TEXT_01')
                    // self.coolFeature1Title = this.setDynamicSection(this.getAllSiteContents, 'COOL_FEATURE_LABEL_01')
                    // self.coolFeature1Desc = this.setDynamicSection(this.getAllSiteContents, 'COOL_FEATURE_TEXT_01')
                    // self.coolFeature2Title = this.setDynamicSection(this.getAllSiteContents, 'COOL_FEATURE_LABEL_02')
                    // self.coolFeature2Desc = this.setDynamicSection(this.getAllSiteContents, 'COOL_FEATURE_TEXT_02')
                    // self.coolFeature3Title = this.setDynamicSection(this.getAllSiteContents, 'COOL_FEATURE_LABEL_03')
                    // self.coolFeature3Desc = this.setDynamicSection(this.getAllSiteContents, 'COOL_FEATURE_TEXT_03')
                    // self.coolFeature4Title = this.setDynamicSection(this.getAllSiteContents, 'COOL_FEATURE_LABEL_04')
                    // self.coolFeature4Desc = this.setDynamicSection(this.getAllSiteContents, 'COOL_FEATURE_TEXT_04')
                    // self.coolFeature5Title = this.setDynamicSection(this.getAllSiteContents, 'COOL_FEATURE_LABEL_05')
                    // self.coolFeature5Desc = this.setDynamicSection(this.getAllSiteContents, 'COOL_FEATURE_TEXT_05')
                    // self.coolFeature6Title = this.setDynamicSection(this.getAllSiteContents, 'COOL_FEATURE_LABEL_06')
                    // self.coolFeature6Desc = this.setDynamicSection(this.getAllSiteContents, 'COOL_FEATURE_TEXT_06')
                    // self.coolFeature7Title = this.setDynamicSection(this.getAllSiteContents, 'COOL_FEATURE_LABEL_07')
                    // self.coolFeature7Desc = this.setDynamicSection(this.getAllSiteContents, 'COOL_FEATURE_TEXT_07')
                    // self.coolFeature8Title = this.setDynamicSection(this.getAllSiteContents, 'COOL_FEATURE_LABEL_08')
                    // self.coolFeature8Desc = this.setDynamicSection(this.getAllSiteContents, 'COOL_FEATURE_TEXT_08')
                    // self.coolFeature9Title = this.setDynamicSection(this.getAllSiteContents, 'COOL_FEATURE_LABEL_09')
                    // self.coolFeature9Desc = this.setDynamicSection(this.getAllSiteContents, 'COOL_FEATURE_TEXT_09')
                    self.personalPlaylistTitle = this.setDynamicSection(this.getAllSiteContents, 'PROFILE_YOUR_PLAYLIST_LABEL')
                    self.trendingPlaylistTitle = this.setDynamicSection(this.getAllSiteContents, 'PROFILE_TONE_PLAYLIST_LABEL')
                    self.corpPlaylistTitle = this.setDynamicSection(this.getAllSiteContents, 'PROFILE_CORP_PLAYLIST_LABEL')
                    self.progressHeading1 = this.setDynamicSection(this.getAllSiteContents, 'PROGRESS_TAB_HDNG_1')
                    self.progressHeading2 = this.setDynamicSection(this.getAllSiteContents, 'PROGRESS_TAB_HDNG_2')
                    self.progressHeading3 = this.setDynamicSection(this.getAllSiteContents, 'PROGRESS_TAB_HDNG_3')
                    self.progressEmptyTakeawayHdng1 = this.setDynamicSection(this.getAllSiteContents, 'PROFILE_EMPTY_TAKEAWAY_1')
                    self.progressEmptyTakeawayHdng2 = this.setDynamicSection(this.getAllSiteContents, 'PROFILE_EMPTY_TAKEAWAY_2')
                    self.progressEmptyTakeawayHdng3 = this.setDynamicSection(this.getAllSiteContents, 'PROFILE_EMPTY_TAKEAWAY_3')
                    self.progressEmptyTakeawayHdng4 = this.setDynamicSection(this.getAllSiteContents, 'PROFILE_EMPTY_TAKEAWAY_4')
                }
            })
            // if (param && param === 'playlist') {
            //     this.switchTab('playlist')
            // } else
            if (this.getCardExpiryDays < 5 && this.user.ccExpAlarmFlag === 2) {
                setTimeout(() => {
                    $('html,body').animate({ scrollTop: $('#updatepaymentmethod').offset().top }, 800)
                    this.showUpdatePayment()
                }, 800)
            }
//            this.$store.dispatch('GETUSERPLAYLISTSWITHVIDEOS', this.user.userId).then(() => {
//                // this.charities = this.getAuthUserVideos
//            })
        }
    }
//    $('.ellipsis').on('click', function () {
//        console.log('ghghjjhgjh')
//        $('#tabs-1').toggleClass('hide')
//    })
</script>
<style scoped>
    .profile .tabContent .personalize .personalizeText {
        padding: 35px 101px 40px !important;
    }
    .accountContentBox .accountRight form .formName.highlight {
        border: 1px solid #f0617d;
        padding-left: 10px;
        padding-right: 10px;
    }
    .pinkh3 {
        color:#f0617d;
    }
    .slider.responsive-slick-imagelist img {
    max-height: 80px;
    object-fit: contain;
    object-position: 50% 50%;
    }

    .slider.responsive-slick-imagelist p.text-wrap-title {
    font-size: 12px;
    }
    .carousalbutton{
        float: right;
        background: #f0617d;
        border: none;
        color: white;
        outline: none;
        font-size: 14px;
        width: 100%;
        padding: 5px 0px 5px;
        border-radius: 3px;
    }
    button.carousalbutton.selected {
        box-shadow: inset 0px 0px 0px 1px #f0617d;
        box-sizing: border-box;
        background: #fff;
        color: #f0617d;
    }
     form.interestButtonList>.interest-container>div.btn-group>button.min-padding.checkbox-btn {
         padding: 5px 0 10px;
         margin: 5px 0;
         background: #f0617d;
         color: #fff;
         width: 49.5% !important;
         line-height: 1.3;
     }
      form.interestButtonList>.interest-container>div.btn-group>button.min-padding.checkbox-btn-days {
         padding: 5px 0 10px;
         margin: 5px 0;
         background: #f0617d;
         color: #fff;
         width: 38.5% !important;
         line-height: 1.3;
     }
    #paypal-button {
        margin-top: 0;
        text-align: left;
    }
    .interestlist button.min-padding.checkbox-btn {
        padding: 5px 0 10px;
        margin: 5px 0;
        /*background: #ffffff;*/
        /*color: #f0617d;*/
        width: 48.2% !important;
        line-height: 1.3;
        margin: 5px 10px;
        transition:all 1s ease;
    }
    .interestlist button.min-padding.checkbox-btn-days {
        padding: 5px 0 10px;
        margin: 5px 0;
        /*background: #ffffff;*/
        /*color: #f0617d;*/
        width: 30.2% !important;
        line-height: 1.3;
        margin: 5px 5px;
        transition:all 1s ease;
    }
    .interestlist button.min-padding.checkbox-btn:hover {
        /*background: #fff;*/
        /*color: #f0617d; */
    }
    .radiowrapper {
        padding: 0 0 20px;
        color: #f0617d;
        text-align: left;
    }
    button.min-padding.checkbox-btn.active {
        /*background: #f0617d !important;*/
    }
    .row.notstripes .col-md-12 {
        border: 1px solid #ddd;
        padding-top: 15px;
        padding-bottom: 15px;
        margin-left: 15px;
        margin-right: 15px;
        width: auto;
        float: none;
        display: block;
        overflow: hidden;
    }
    .row.notstripes {
        clear: both;
    }
    .row.notstripes div#paypal-button {
        text-align: center;
    }

    .row.notstripes h5 {
        padding: 0 0 0px;
    }
    /*#paypal-button {
        border-top: 1px solid #ddd;
        margin: 20px 0 0 !important;
        /* border: 1px solid #ddd; */
        /* clear: both; */
    /*}*/

    div#card-element {
        margin: 20px 0 20px;
        border: 1px solid #ddd;
        padding: 20px 10px;
    }
    .accountContentBox .accountRight form .formName h5.paymentmethodh5 {
        border-bottom: 1px solid #ddd;
        margin: 0 0 20px;
        padding: 0 0 10px;
        font-size: 15px;
    }
    @media(max-width:767px){
        form.interestButtonList>.interest-container>div.btn-group>button.min-padding.checkbox-btn {
            width: 100% !important;
        }
        form.interestButtonList>.interest-container>div.btn-group>button.min-padding.checkbox-btn-days {
            width: 100% !important;
        }
        .interestlist .submit-btn .btn {
            width: 100%;
        }
        .interestlist .checkbox-btn:hover {
            /*background: inherit;*/
            /*color: inherit;*/
        }
        .interestlist .checkbox-btn.active:hover {
            /*color: #fff;*/
            /*background: #f0617d;*/
        }
        .interestlist button.min-padding.checkbox-btn {
            padding: 5px 0 10px;
            margin: 5px 0;
            /*background: #ffffff;*/
            /*color: #f0617d;*/
            width: 100% !important;
            line-height: 1.3;
            margin: 0px 0px;
        }
        .interestlist button.min-padding.checkbox-btn-days {
            padding: 5px 0 10px;
            margin: 5px 0;
            /*background: #ffffff;*/
            /*color: #f0617d;*/
            width: 100% !important;
            line-height: 1.3;
            margin: 0px 0px;
        }
    }

    .profile-heading {
        text-transform: none;
    }
    .profile div#tabs-2.tabContent img {
        height: auto !important;
    }

    .profile div#tabs-2.tabContent .favnumbers {
        display: flex;
        align-items: center;
        justify-content: space-around;
        justify-items: stretch;
        flex-direction: column;
        font-size: 24px;
    }

    .profile div#tabs-2.tabContent .favnumbers > div > span {
        padding: 0;
        line-height: 1;
        display: inline;
    }

    .profile div#tabs-2.tabContent .favnumbers small {
        font-size: 12px;
        display: block;
    }

    .profile div#tabs-2.tabContent .favnumbers > div {
        line-height: 1;
    }

    .profile div#tabs-2.tabContent .favnumbers i.fa {
        margin: 0;
    }
    div#tabs-2 h3 {
        color: #232323;
        font-weight:700;
    }
    /*First CSS*/
    button.downbutton {
        position: absolute;
        bottom: 0;
        width: 100%;
        left: 0;
        right: 0;
        display: block;
        text-align: center;
        background-color: #f0617d;
        z-index: 100;
        border: 0 none transparent;
        padding:10px;
    }
    .pinkputlinepannel{
        background:#fff;
    }

    .takeawaysholder, .pinkputlinepannel, .progressbarsholder {
        position: relative;
        transition: all 1s ease;
    }

    button.downbutton > .fa {
        display: block;
        font-size: 30px;
    }

    .progressbarsholder.expand {
        max-height: 3000px;
    }

    .pinkputlinepannel.expand {
        max-height: 3000px;
    }

    .takeawaysholder.expand {
        max-height: 3000px;
    }
    /*Second CSS*/

    button.downbutton {
        position: absolute;
        bottom: 0;
        width: 100%;
        left: 0;
        right: 0;
        display: block;
        text-align: center;
        background-color: inherit;
        z-index: 100;
        border: 0 none transparent;
        padding:10px;
    }
    .pinkputlinepannel{
        background:#fff;
    }

    .takeawaysholder , .pinkputlinepannel , .progressbarsholder {
        position: relative;
        transition: all 1s ease;
    }

    button.downbutton > .fa {
        display: block;
        font-size: 30px;
    }

    .progressbarsholder.expand {
        max-height: 3000px;
    }

    .pinkputlinepannel.expand {
        max-height: 3000px;
    }

    .takeawaysholder.expand {
        max-height: 3000px;
    }

    .progress.mb-3 {
     display: flex;
    }

    .progessandstar {
        display: flex;
    }

    .progessandstar > .progress {
        flex: 100;
    }
    .progessandstar .fa-star {font-size: 20px !important;margin-left:5px;color:#faea63;transform: rotate(45deg);top: -10px;position: relative;}
    /*Third CSS*/
    sir kindly add these additional classes

    button.downbutton:focus {
        outline: 0 none transparent;
    }

    .pinkputlinepannel.expand {
        padding-bottom: 60px;
    }

    .expand i.fa.fa-chevron-down {transform: rotate(180deg);}

    .progressbarsholder.expand {
        padding-bottom: 60px;
    }

    .takeawaysholder.expand {
        padding-bottom: 80px;
    }
   /*Commented to display arrows on mobile*/
    /*@media(max-width:768px){*/
    /*    button.downbutton {*/
    /*        display: none !important;*/
    /*    }*/

    /*    .pinkputlinepannel {*/
    /*        max-height: none !important;*/
    /*    }*/

    /*    .takeawaysholder {*/
    /*        max-height: none !important;*/
    /*    }*/

    /*    .progressbarsholder {*/
    /*        max-height: none !important;*/
    /*    }*/
    /*}*/
    buttton.downbutton:focus{border:0 none transparent;outlinie:0 none transparent;}
    button.downbutton:focus {
        outline: 0 none transparent !important;
    }
    button.downbutton:active {
        outline: 0 none transparent !important;
    }
    /*Fourth CSS*/
    .takeawaysholder button.downbutton {
        background: #f0617d;
        background-clip: padding-box;
        border: 10px solid transparent;
    }

    .takeawaysholder button.downbutton:after {
        position: absolute;
        display: block;
        height: 10px;
        width: auto;
        content: "";
        bottom: -10px;
        left: -10px;
        right: -10px;
        background: #faa51e;
    }

    /*.pinkputlinepannel .fa-chevron-down:before {color: #f0617d;}*/
    .takeawaysholder li {
        font-weight: 600;
        text-align: left;
        white-space: pre-line !important;
    }
    .pinkputlinepannel button{background-color:#fff !important;}
    .watcedvideotitle {
        padding-top: 20px;
        font-size: 18px;
        font-weight: 700;
        color: #f0617d;
        line-height: 1;
    }
    .watcedvideotitle span {
        font-size: 150%;
    }
    .pinkputlinepannel h3 {
        margin-top: 0;
    }
    /*fifth CSS*/
    li.mobile-event-star i.fa.fa-star.showmobile {
        display: none;
    }
    @media(max-width:767px){

        li.mobile-event-star i.fa.fa-star.showmobile {
            display: inline;
            color: #faa51e;
            transform: rotate(45deg);
            font-size: 13px;
            margin-right: 10px;
        }

        li.mobile-event-star {
            list-style: none;
            padding: 0 !important;
            margin: 0 !important;
        }

        .pinkputlinepannel:first-of-type ul {
            margin: 0 !important;
            padding-left: 0 !important;
        }
    }
    /*Changes for Corporate Modal*/
    .sharesmallpink.watchVideoModal .modal-dialog  .watchVideoModalHeader {
        background: #f0617d;
        color: #fff;
        font-size: 25px;
        text-align: left;
        padding: 15px 25px;
        font-weight: 700;
    }
    .sharesmallpink.watchVideoModal .modal-dialog .modal-body p{
        padding: 0;
        margin: 0 0 20px;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default {
        background: #fff;
        color: #333;
        border: 1px solid #cacaca;
        width: 100%;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body {
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body button.btn.btn-primary.btn-pink {
        background: #f0617d;
        width: 100%;
        margin: 0;
        border: 1px solid #f0617d;
    }
    @media(max-width:475px){
        .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default {
            padding-left: 0;
            padding-right: 0;
        }
    }
    .row.sharefb {
        background: #eee;
        margin-left: 0;
        margin-right: 0;
    }

    .row.sharefb > div {
        padding: 5px;
        text-align: left;
    }

    .row.sharefb .col-sm-5 img {
        max-width: 100%;
    }
    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p {
        font-size: 14px;
        font-weight: 300;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h6 {
        text-transform: uppercase;
        font-size: 12px;
        margin: 10px 0 5px;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h4 {
        margin: 0 0 5px;
        font-weight:700;
    }
    .showmobile{display:none;}
    @media(max-width:767px){
        .usernamenimg.text-left {
            display: none;
        }
        .showmobile{
            display: block;
        }
        .alert.alert-default {
            background: #eee;
        }

        .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p {
            display: none;
        }
        .sharesmallpink.watchVideoModal .modal-dialog .watchVideoModalHeader .watchVideoArrow {
            top: 1px;
            right: -13px;
        }
        .row.sharefb {
            display: flex;
            align-items: center;
        }
        .pinksidebarmin{
            padding:0 !important;
            display: flex;
            flex-direction: column;
            flex-basis: auto;
            display: flex ;
            align-items: stretch ;
            justify-content: center;
        }

        .pinksidebarmin > * {
            padding: 6px 0 !important;
            margin: 0 !important;
            flex: 100;
            text-align:center;
        }
    }
    .interestlist {
        clear: both;
    }

    .interestlist .interest-container {
        width: 100%;
    }

    .box-size {
        height: 10px;
    }
    .mb-4 {
        margin-bottom: 40px;
    }


</style>
<!--<style>-->
    <!--.interestlist .interestButtonList .checkbox-btn:hover{-->
        <!--background: #fff !important;-->
        <!--color: #f0617d !important;-->
    <!--}-->
    <!--.interestlist .interestButtonList .checkbox-btn.active:hover {-->
        <!--background: #f0617d !important;-->
        <!--color: #fff !important;-->
    <!--}-->
<!--</style>-->
<style>
    @media(max-width:767px){
        .sharesmallpink.watchVideoModal span.multiselect__tag {
            white-space: normal;
            width: 100%;
        }
    }
    form.updateName label.open.checkbox.primary {
        color: #f0617d;
        padding-left: 24px;
        text-align: left;
    }
    .interestlist .checkbox-btn.active:hover {
        /*background: #f0617d !important;*/
        /*color: #fff !important;*/
    }
    .interestlist .checkbox-btn:hover {
        /*background: #fff;*/
        /*color: #f0617d !important;*/
    }
    .hide + .backdropformenu{display:none;}
</style>
<style scoped>
    .profile .tabContent  .yourFaves div.btn-group {
        position: absolute;
        right: 50px;
        bottom: 0;
    }

    button.dropdown-toggle.ellipsis.pull-right {
        background: transparent;
        border: 0 none transparent;
        padding: 0;
    }

    button.dropdown-toggle.ellipsis.pull-right {
        font-size: 21px;
        top: 0;
    }

    .yourFaves div.btn-group {
        bottom: 5px;
        height: 29px;
    }

    button.dropdown-toggle.ellipsis.pull-right li label {
        padding: 30px;
    }

    button.dropdown-toggle.ellipsis.pull-right+ ul li label,
    button.dropdown-toggle.ellipsis.pull-right+ ul li a {
        padding: 3px 15px;
        margin-bottom: 5px;
        display: block;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control,
    button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control {
        height: 30px;
        padding: 5px 30px 5px 5px;;
    }

    button.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control + i.fa.fa-plus-circle,
    button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control + i.fa.fa-plus-circle {
        position: absolute;
        top: 6px;
        font-size:24px;
        right:20px;
        cursor: pointer;
    }

    button.dropdown-toggle.ellipsis.pull-right+ ul li label,
    button.dropdown-toggle.ellipsis.pull-right+div + ul li label{
        position:relative;
    }
    button.dropdown-toggle.ellipsis.pull-right+ div + ul,
    button.dropdown-toggle.ellipsis.pull-right+ ul {
        left: 0;
        right: auto;
        width: 230px;
        background: #fff;
        border: 1px solid #ddd;
        border-radius: 5px;
        top: 100%;
        position: absolute;
        z-index: 5000;
        list-style: none;
        text-align: left;
        padding: 15px;
    }
    .backdropformenu{
        position:fixed;
        z-index:4900;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background: transparent;
    }
    li.divider {
        border-bottom: 1px solid #ddd;
        margin: 5px -15px;
    }
    .favnumbers {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 60px;
        text-align: center;
        z-index: 500;
        color: #fff;
        background: #f0617d;
    }

    .viderowraper {
        position: relative;
    }

    .favnumbers span {
        display: block;
        padding: 14px 0;
    }

    .favnumbers {
        font-size: 30px;
        font-weight: 900;
    }
    @media (max-width: 767px) and (min-width: 320px){
        .profile .tabs-content .tabs ul li {
            width: AUTO;
            box-sizing: border-box;
            margin: 0;
        }
    }
    .profile .tabContent img.menuiconbutton {
        height: 24px;
        width: 37px;
    }
    .plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul {
        left: auto ;
        right: 0;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    label.notificationwithcheckboxes span{
        font-size: 10px;
    }

    span.removed {
        color: red;
    }
    span.added {
        color: #4caa98;
    }

    label.notificationwithcheckboxes {
        position: relative;
        display:block;
    }



    .container.boxescontiner .row.nospace.flexrow:nth-of-type(even) > div:nth-of-type(even) {
        background: #faa51e;
    }
    .container.boxescontiner .row.nospace.flexrow:nth-of-type(odd) > div:nth-of-type(odd) {
        background: #faa51e;
    }

    .container.boxescontiner .row.nospace.flexrow:nth-of-type(odd) > div:nth-of-type(even) {
        background: #f0617d;
    }
    .container.boxescontiner .row.nospace.flexrow:nth-of-type(even) > div:nth-of-type(odd) {
        background: #f0617d;
    }
    .col-sm-4 {}

    .container.boxescontiner .row.nospace.flexrow > div {
        padding: 15px;
        align-items: center;
        display: flex;
        flex-direction: column;
    }



    html {}

    .container.boxescontiner .row.nospace.flexrow {
        display: flex;
    }

    .container.boxescontiner .row.nospace.flexrow > div img {
        height: auto;
        width: auto;
    }

    .container.boxescontiner .row.nospace.flexrow > div p {
        text-align: center;
        color: #fff;
        font-size: 14px;
        font-weight: 700;
    }

    .container.boxescontiner .row.nospace.flexrow > div p.descriptionservices {
        text-overflow: unset;
        white-space: normal;
        font-size: 19px;
        text-align: left;
    }


    .container.boxescontiner .row.nospace.flexrow > div p.descriptionservices {
        /*transform:rotateY(0.25turn);*/
        animation-duration: 0.25s;
        animation-name: fadeout;
        animation-count:1;
        animation-fill-mode: forwards;
        position: absolute;
        backface-visibility: hidden;
        top:15px;
        left:0;
    }
    .container.boxescontiner .row.nospace.flexrow > div.active p.descriptionservices {

        animation-duration: 0.25s;
        animation-name: fadein;
        animation-count:1;
        animation-fill-mode: forwards;
    }
    .container.boxescontiner .row.nospace.flexrow > div p.descriptionservices {
        margin: 0px 0;
        padding: 0 20px;
    }
    img.bagimage {
        position: absolute;
        left: 0;
        right: 0;
        height: 100%!important;
        width: 100% !important;
        top: 0;
        display: block;
        bottom: 0;
        object-fit: cover;
        object-position: center;
    }

    .container.boxescontiner .row.nospace.flexrow > div {
        position: relative;
    }
    .modal {
        z-index: 5000;
    }
    /*.swal2-modal.swal2-show {*/
        /*z-index: 5110;*/
    /*}*/
    @keyframes rotateout {
        0%   {
            transform:rotateY(0deg) ;
        }

        100% {
            transform:rotateY(180deg) ;
        }
    }
    @keyframes rotatein {
        0%   {
            transform:rotateY(-180deg);
        }

        100% {
            transform:rotateY(0deg) ;
        }
    }


    @keyframes fadeout {
        0%   {
            opacity:1
        }

        100% {
            opacity:0
        }
    }
    @keyframes fadein {
        0%   {
            opacity:0;
        }

        100% {
            opacity:1 ;
        }
    }


    @media(max-width:767px){
        .container.boxescontiner .row.nospace.flexrow {
            display: block !important;
        }
    }
    .container.boxescontiner {
        padding-bottom: 50px;
    }
    @media(max-width:450px){
        .pimg {
            padding: 25px;
        }
        .container.boxescontiner .row.nospace.flexrow > div.active p.descriptionservices {
            font-size: 17px;
        }
    }
    @media(max-width:350px){
        .pimg {
            padding: 40px;
        }
        .container.boxescontiner .row.nospace.flexrow > div.active p.descriptionservices {
            font-size: 17px;
        }
    }
    @media(min-width:768px) and (max-width:991px) {
        .container.boxescontiner .row.nospace.flexrow > div p.descriptionservices {
            font-size: 15px !important;
        }

        .container.boxescontiner .row.nospace.flexrow > div .pimg {
            padding: 10px;
        }
    }@media(min-width:992px) and (max-width:1200px) {
        .container.boxescontiner .row.nospace.flexrow > div .pimg {
            padding: 20px;
        }
    }
    .favnumbers .fa {
        display: block;
        margin: 0px 0 15px;
    }

    @media(min-width:1025px){
        .favnumbers .fa{
            display:none;
        }
        .favnumbers .fa:hover{
            cursor:pointer;
        }
        .viderowraper:hover .favnumbers .fa{
            display:block;
        }
    }
    @media(max-width: 1024px){
        .favnumbers .fa {
            font-size: 22px;
        }

        .favnumbers span {
            font-size: 20px;
            padding: 10px 0 !important;
            margin: 0 !important;
        }
    }
   /* !**!CSS Classes for Progress Tab*/
    .progressbarsholder {
        background: #f0617d !important;
        padding: 20px;
        color: #fff;
        text-align: left;
        max-height: 410px;
        min-height: 410px;
        overflow: hidden;
    }

    .progressbarsholder .progress-bar {
        background-color: #adc736;
    }

    .progressbarsholder h3 {
        font-weight: bold;
        font-size: 23px;
    }

    .takeawaysholder {
        background: #faa51e;
        padding: 20px;
        color: #fff;
        max-height: 410px;
        min-height: 410px;
        text-align: center;
        overflow: hidden;
    }


    .takeawaysholder h3 {
        font-weight: bold;
        font-size: 23px;
    }

    .takeawaysholder ul {
        margin: 0;
        padding: 0;
        list-style-position: inside;
    }

    .pinkputlinepannel {
        border: 5px solid #f0617d;
        padding: 15px;
        max-height: 190px;
        min-height: 190px;
        overflow: hidden;
    }

    .pinkputlinepannel ul {
        /*list-style: none;*/
        /*cursor: pointer;*/
        text-align: left;
        padding: 25px;
        margin: 0;
    }

    .pinkputlinepannel h3 {
        font-size: 21px;
        font-weight: 900;
        color: #f0617d;
    }

    .pinkputlinepannel + .pinkputlinepannel {
        margin-top: 30px;
    }
    .a.btn-group {
        margin: 0px;
    }
    .headerlevel2 h2 {
        color: #0D0D0D;
        font-weight: 900;
        margin: 20px 0 20px 0;  /* top right bottom left */
    }
    .headerlevel3 h3 {
        color: #0D0D0D;
        font-weight: 500;
        margin: 0px 0 0px 0;  /* top right bottom left */
    }
</style>
<style>
    #playlistshare-form textarea.form-control {
        max-height: 100px;
        min-height: 100px;
        height: 100px !important;
        width: 100%;
        max-width: 100%;
        min-width: 100%;
    }
    #playlistshare-form button.btn.formButton.btn-block {
        background: #f0617d;
        border-radius: 7px;
        min-width: 0;
        width: auto;
        padding: 14px;
    }
    .container.boxescontiner .row.nospace.flexrow > div .pimg {
        transition: all 1s ease;
        animation-duration: 0.25s;
        animation-name: fadein;
        /*animation-name: rotatein;*/
        animation-count:1;
        z-index:100;
        animation-fill-mode: forwards;
        backface-visibility: hidden;
    }
    .container.boxescontiner .row.nospace.flexrow > div.active .pimg {
        animation-name: fadeout;
        animation-count:1;
        animation-fill-mode: forwards;
    }

</style>



// WEBPACK FOOTER //
// Profile.vue?4bc54160